const mainRoutes = [

    {
        path: '/',
        name: 'index',
        //redirect: '/www/index.html',
        component: () =>
            import ('./views/common/index/Index.vue'),
        meta: {
            pageId: 10000021111,
            title: '首页',
            keyword: '',
            description: ''
        }
    },

    {
        path: '/work',
        name: 'work',
        //redirect: '/testall',
        component: () =>
            import ('./views/demo/testall/TestAll.vue'),
        meta: {
            pageId: 10000021111,
            title: '工作台',
            keyword: '',
            description: ''
        }
    },
    {
        path: '/testall',
        name: 'testall',
        component: () =>
            import ('./views/demo/testall/TestAll.vue'),
        meta: {
            pageId: 10000021111,
            title: '测试所有',
            keyword: '',
            description: ''
        }
    },
    {
        path: '/demo/userlist',
        name: 'demo_userlist',
        component: () =>
            import ('./views/demo/userlist/UserList.vue'),
        meta: {
            pageId: 10001,
            title: '用户列表',
            keyword: '用户',
            description: '用户列表。。。。。'
        }
    },
    {
        path: '/company/emp/pendingemp',
        name: 'company_emp_pendingemp',
        component: () =>
            import ('./views/company/emp/pendingemp/list/Pendingemp.vue'),
        meta: {
            pageId: 11000,
            title: '待入职列表',
            keyword: '待入职列表',
            description: '待入职列表'
        },
        redirect: '/company/emp/pendingemp/list',
        children: [{
            path: '/company/emp/pendingemp/list',
            name: 'company_emp_pendingemp_list',
            component: () =>
                import ('./views/company/emp/pendingemp/hiredlist/HiredList.vue'),
            meta: {
                pageId: 11001,
                title: '待入职列表',
                keyword: '待入职列表',
                description: '待入职列表'
            }
        }, {
            path: '/company/emp/abandon/list',
            name: 'company_emp_abandon_list',
            component: () =>
                import ('./views/company/emp/pendingemp/abandonlist/AbandonList.vue'),
            meta: {
                pageId: 11002,
                title: '放弃入职列表',
                keyword: '放弃入职列表',
                description: '放弃入职列表'
            }
        }]
    }, {
        path: '/demo/useradd',
        name: 'demo_useradd',
        component: () =>
            import ('./views/demo/useradd/Add.vue'),
        meta: {
            pageId: 10001,
            title: '用户列表',
            keyword: '用户',
            description: '用户列表。。。。。'
        }
    },
    {
        path: '/company/emp/pendingemp',
        name: 'company_emp_pendingemp',
        component: () =>
            import ('./views/company/emp/pendingemp/list/Pendingemp.vue'),
        meta: {
            pageId: 10001,
            title: '待入职列表',
            keyword: '待入职列表',
            description: '待入职列表。。。。。'
        }
    },
    {
        path: '/company/emp/leaveemp',
        name: 'company_emp_leaveemp',
        component: () =>
            import ('./views/company/emp/leaveemp/Leaveemp.vue'),
        meta: {
            pageId: 12001,
            title: '离职列表',
            keyword: '离职列表',
            description: '离职列表。。。。。'
        }
    },
    {
        path: '/company/set/salaryset',
        name: 'salaryset',
        component: () =>
            import ('./views/company/set/salaryset/index/Index.vue'),
        meta: {
            pageId: 10002,
            title: '薪酬设置',
            keyword: '薪酬',
            description: '薪酬设置。。。。。'
        },
    },
    {
        path: '/company/set/guideset',
        name: 'salaryset_guideset',
        component: () =>
            import ('./views/company/set/salaryset/guideset/GuideSet.vue'),
        meta: {
            pageId: 10002,
            title: '薪酬设置_引导页',
            keyword: '薪酬',
            description: '薪酬设置。。。。。'
        },
    },
    {
        path: '/company/salarymodule/newsalary/guidepage',
        name: 'salary_guidepage',
        component: () =>
            import ('./views/company/salarymodule/newsalary/guidepage/GuidePage.vue'),
        meta: {
            pageId: 10002,
            title: '智能薪酬_引导页',
            keyword: '智能薪酬引导页',
            description: '智能薪酬引导页。。。。。'
        },
    },

    {
        path: '/company/set/salaryset/oldsubject',
        name: 'salaryset_oldsubject',
        component: () =>
            import ('./views/company/set/salaryset/oldsubject/OldSubject.vue'),
        meta: {
            pageId: 10002,
            title: '薪酬信息设置',
            keyword: '薪酬',
            description: '薪酬设置。。。。。'
        },
    },
    {
        path: '/company/set/salaryset/allowance',
        name: 'salaryset_allowance',
        component: () =>
            import ('./views/company/set/salaryset/allowance/Allowance.vue'),
        meta: {
            pageId: 10012,
            title: '津贴方案设置',
            keyword: '薪酬',
            description: '薪酬设置。。。。。'
        },
    },
    {
        path: '/company/set/salaryset/bounty',
        name: 'salaryset_bountyset',
        component: () =>
            import ('./views/company/set/salaryset/bounty/BountySet.vue'),
        meta: {
            pageId: 1810012,
            title: '津贴字段',
            keyword: '薪酬',
            description: '薪酬设置'
        },
    },
    {
        path: '/company/set/salaryset/subject',
        name: 'salaryset_subject',
        component: () =>
            import ('./views/company/set/salaryset/subject/Subject.vue'),
        meta: {
            pageId: 10002,
            title: '薪酬设置',
            keyword: '薪酬',
            description: '薪酬设置。。。。。'
        },
    },
    {
        path: '/company/set/morsalray',
        name: 'salaryset_subject',
        component: () =>
            import ('./views/company/set/list/List.vue'),
        meta: {
            pageId: 10002,
            title: '薪酬设置',
            keyword: '薪酬',
            description: '薪酬设置。。。。。'
        },
    },
    // {
    //     path: '/company/dangandetail',
    //     name: 'company_dangandetail',
    //     component: () =>
    //         import ('./views/company/dangandetail/Dangandetail.vue'),
    //     meta: {
    //         pageId: 10006,
    //         title: '档案信息',
    //         keyword: '档案',
    //         description: '档案信息'
    //     },
    // },
    {
        path: '/company/dangandetail',
        name: 'company_dangandetail',
        component: () =>
            import ('./views/company/emp/info/archives/Archives.vue'),
        meta: {
            pageId: 10007,
            title: '档案信息',
            keyword: '档案',
            description: '档案信息'
        },
    },
    {
        path: '/company/growlog',
        name: 'company_growlog',
        component: () =>
            import ('./views/company/growlog/Growlog.vue'),
        meta: {
            pageId: 10006,
            title: '成长记录',
            keyword: '成长记录',
            description: '成长记录'
        },
    },
    {
        path: '/company/materialattachment',
        name: 'company_materialattachment',
        component: () =>
            import ('./views/company/materialattachment/Materialattachment.vue'),
        meta: {
            pageId: 10006,
            title: '材料附件',
            keyword: '材料附件',
            description: '材料附件'
        },
    },
    // {
    //     path: '/company/baseinfo',
    //     name: 'company_baseinfo',
    //     component: () =>
    //         import ('./views/company/baseinfo/Baseinfo.vue'),
    //     meta: {
    //         pageId: 10006,
    //         title: '基本信息',
    //         keyword: '基本信息',
    //         description: '基本信息'
    //     },
    // },
    {
        path: '/company/baseinfo',
        name: 'company_baseinfo',
        component: () =>
            import ('./views/company/emp/info/baseinfo/BaseInfo.vue'),
        meta: {
            pageId: 10011,
            title: '基本信息',
            keyword: '基本信息',
            description: '基本信息'
        },
    },
    // {
    //     path: '/company/postinfo',
    //     name: 'company_postinfo',
    //     component: () =>
    //         import ('./views/company/postinfo/Postinfo.vue'),
    //     meta: {
    //         pageId: 10006,
    //         title: '岗位信息',
    //         keyword: '岗位信息',
    //         description: '岗位信息'
    //     },
    // },
    {
        path: '/company/postinfo',
        name: 'company_postinfo',
        component: () =>
            import ('./views/company/emp/info/postinfo/PostInfo.vue'),
        meta: {
            pageId: 10008,
            title: '岗位信息',
            keyword: '岗位信息',
            description: '岗位信息'
        },
    },
    {
        path: '/company/salaryinfo',
        name: 'company_salaryinfo',
        component: () =>
            import ('./views/company/emp/info/compensation/Compensation.vue'),
        meta: {
            pageId: 10006,
            title: '薪酬信息',
            keyword: '薪酬信息',
            description: '薪酬信息'
        },
    },
    {
        path: '/company/contractinfo',
        name: 'company_contractinfo',
        component: () =>
            import ('./views/company/contractinfo/Contractinfo.vue'),
        meta: {
            pageId: 10006,
            title: '合同信息',
            keyword: '合同信息',
            description: '合同信息'
        },
    },

    {
        path: '/company/commonhrform',
        name: 'company_commonhrform',
        component: () =>
            import ('./views/company/commonhrform/Commonhrform.vue'),
        meta: {
            pageId: 10006,
            title: '常用人事表格',
            keyword: '常用人事表格',
            description: '常用人事表格'
        },
    },

    {
        path: '/salaryset/oftime',
        name: 'salaryset_oftime',
        component: () =>
            import ('./views/company/set/salaryset/oftime/OfTime.vue'),
        meta: {
            pageId: 10002,
            title: '薪酬设置',
            keyword: '薪酬',
            description: '薪酬设置。。。。。'
        },
    },
    {
        path: '/notice/index',
        name: 'notice_index',
        component: () =>
            import ('./views/company/notice/index/Index.vue'),
        meta: {
            pageId: 10002,
            title: '公告列表',
            keyword: '公告',
            description: '公告。。。。。'
        },
    }, {
        path: '/notice/addnotice',
        name: 'notice_addnotice',
        component: () =>
            import ('./views/company/notice/addnotice/AddNotice.vue'),
        meta: {
            pageId: 10002,
            title: '添加公告',
            keyword: '公告',
            description: '公告。。。。。'
        },
    },
    {
        path: '/notice/message',
        name: 'notice_message',
        component: () =>
            import ('./views/company/notice/message/Message.vue'),
        meta: {
            pageId: 10002,
            title: '消息列表',
            keyword: '消息列表',
            description: '消息列表。。。。。'
        },
    },

    {
        path: '/emp/list',
        name: 'emp_list',
        component: () =>
            import ('./views/company/emp/onjob/emplist/EmpList.vue'),
        meta: {
            pageId: 20100,
            title: '在职员工',
            keyword: '',
            description: ''
        },
        children: []
    },
    {
    	path:"/emp/empsort",
    	name:"emp_sort",
    	component:()=>
    		import('./views/company/emp/onjob/empsort/EmpSort.vue'),
    	meta:{
    		pageId: 20100009,
            title: '员工排序',
            keyword: '员工排序',
            description: '员工排序'
    	}
    },
    {
    	path:"/emp/importempsort",
    	name:"import_emp_sort",
    	component:()=>
    		import("./views/company/emp/onjob/empsort/importempsort/ImportEmpSort.vue"),
    	meta:{
    		pageId: 20100099,
    		title:"导入员工排序",
    		keyword:'导入员工排序',
            description:'导入员工排序'
    	}
    },
    {
        path: '/company/emp/supplementarylist',
        name: 'company_emp_supplementarylist',
        component: () =>
            import ('./views/company/emp/onjob/supplementarylist/SupplementaryList.vue'),
        meta: {
            pageId: 20221,
            title: '补充信息列表',
            keyword: '',
            description: ''
        },
        children: []
    }, {
        path: '/emp/onjob/positive',
        name: 'emp_onjob_positive',
        component: () =>
            import ('./views/company/emp/onjob/positive/Positive.vue'),
        meta: {
            pageId: 20101,
            title: '员工转正',
            keyword: '',
            description: ''
        },
    }, {
        path: '/emp/onjob/departure',
        name: 'emp_onjob_departure',
        component: () =>
            import ('./views/company/emp/onjob/departure/Departure.vue'),
        meta: {
            pageId: 20102,
            title: '员工离职',
            keyword: '',
            description: ''
        },
    }, {
        path: '/emp/onjob/adjustpost',
        name: 'emp_onjob_adjustpost',
        component: () =>
            import ('./views/company/emp/onjob/adjustpost/AdjustPost.vue'),
        meta: {
            pageId: 20103,
            title: '员工调岗',
            keyword: '',
            description: ''
        },
    }, {
        path: '/emp/onjob/backups',
        name: 'emp_onjob_backups',
        component: () =>
            import ('./views/company/emp/onjob/backups/Backups.vue'),
        meta: {
            pageId: 20105,
            title: '员工备份',
            keyword: '',
            description: ''
        },
    }, {
        path: '/emp/onjob/induction',
        name: 'emp_onjob_induction',
        component: () =>
            import ('./views/company/emp/onjob/empadd2.0/EmpAdd.vue'),
        meta: {
            pageId: 20104,
            title: '员工入职',
            keyword: '',
            description: ''
        },
    }, {
        path: '/emp/onjob/supplementaryinfosetting',
        name: 'emp_onjob_supplementaryinfosetting',
        component: () =>
            import ('./views/company/emp/onjob/supplementaryinfosetting/SupplementaryInfoSetting.vue'),
        meta: {
            pageId: 20107,
            title: '员工入职',
            keyword: '',
            description: ''
        },
    }, {
        path: '/emp/employed/induction',
        name: 'emp_employed_induction',
        component: () =>
            import ('./views/company/emp/entryregistration/empadd2.0/EmpAdd.vue'),
        meta: {
            pageId: 20104,
            title: '员工录用',
            keyword: '',
            description: ''
        },
    },
    {
        path: '/emp/employed/supplement',
        name: 'emp_employed_supplement',
        component: () =>
            import ('./views/company/emp/entryregistration/empadd2.1/EmpAdd.vue'),
        meta: {
            pageId: 20105,
            title: '员工补充信息',
            keyword: '',
            description: ''
        },
    }, {
        path: '/emp/employed/supplementdetail',
        name: 'emp_employed_supplementdetail',
        component: () =>
            import ('./views/company/emp/entryregistration/details2.1/Details.vue'),
        meta: {
            pageId: 20106,
            title: '员工补充信息',
            keyword: '',
            description: ''
        },
    },
    {
        path: '/personal/emp/employed/induction',
        name: 'personal_emp_employed_induction',
        component: () =>
            import ('./views/company/emp/entryregistration/empadd/EmpAdd.vue'),
        meta: {
            pageId: 80104,
            title: '员工录用',
            keyword: '',
            description: ''
        },
    },
    {
        path: '/emp/entryregistration/list',
        name: 'emp_entryregistration_list',
        component: () =>
            import ('./views/company/emp/entryregistration/list/List.vue'),
        meta: {
            pageId: 20200,
            title: '录用审批',
            keyword: '',
            description: ''
        },
    }, {
        path: '/emp/entryregistration/detail',
        name: 'emp_entryregistration_detail',
        component: () =>
            import ('./views/company/emp/entryregistration/details/Details.vue'),
        meta: {
            pageId: 20201,
            title: '录用审批详情',
            keyword: '',
            description: ''
        },
    }, {
        path: '/company/emp/internship/list',
        name: 'company_emp_internship_list',
        component: () =>
            import ('./views/company/emp/internship/list/List.vue'),
        meta: {
            pageId: 120102,
            title: '实习生管理',
            keyword: '',
            description: ''
        },
    }, {
        path: '/company/emp/internship/record',
        name: 'company_emp_internship_record',
        component: () =>
            import ('./views/company/emp/internship/record/Record.vue'),
        meta: {
            pageId: 120103,
            title: '转全职员工记录',
            keyword: '',
            description: ''
        },
    }, {
        path: '/emp/archives/list',
        name: 'emp_archives_list',
        component: () =>
            import ('./views/company/emp/archives/list/List.vue'),
        meta: {
            pageId: 20301,
            title: '员工档案',
            keyword: '',
            description: ''
        },
    }, {
        path: '/emp/archives/add',
        name: 'emp_archives_add',
        component: () =>
            import ('./views/company/emp/archives/add/Add.vue'),
        meta: {
            pageId: 20302,
            title: '员工档案新增编辑',
            keyword: '',
            description: ''
        },
    }, {
        path: '/emp/credit/list',
        name: 'emp_credit_list',
        component: () =>
            import ('./views/company/emp/credit/list/List.vue'),
        meta: {
            pageId: 20401,
            title: '征信管理',
            keyword: '',
            description: ''
        },
    }, {
        path: '/emp/credit/blacklist',
        name: 'emp_credit_blacklist',
        component: () =>
            import ('./views/company/emp/credit/blacklist/Blacklist.vue'),
        meta: {
            pageId: 20501,
            title: '黑名单',
            keyword: '',
            description: ''
        },
    }, {
        path: '/emp/applyrecord/list',
        name: 'emp_applyrecord_list',
        component: () =>
            import ('./views/company/emp/applyrecord/list/List.vue'),
        meta: {
            pageId: 20401,
            title: '申请记录',
            keyword: '',
            description: ''
        },
    }, {
        path: '/emp/applyrecord/detail',
        name: 'emp_applyrecord_detail',
        component: () =>
            import ('./views/company/emp/applyrecord/details/Details.vue'),
        meta: {
            pageId: 20402,
            title: '申请详情',
            keyword: '',
            description: ''
        },
    }, {
        path: '/company/emp/positivemanage/list',
        name: 'company_emp_positivemanage_list',
        component: () =>
            import ('./views/company/emp/positivemanage/list/List.vue'),
        meta: {
            pageId: 21101,
            title: '转正管理列表',
            keyword: '',
            description: ''
        },
    }, {
        path: '/company/emp/positivemanage/tobeconfirmed',
        name: 'company_emp_positivemanage_tobeconfirmed',
        component: () =>
            import ('./views/company/emp/positivemanage/tobeconfirmed/ToBeConfirmed.vue'),
        meta: {
            pageId: 21106,
            title: '待转正管理列表',
            keyword: '',
            description: ''
        },
    }, {
        path: '/company/emp/positivemanage/staytakeeffectlist',
        name: 'company_emp_positivemanage_staytakeeffectlist',
        component: () =>
            import ('./views/company/emp/positivemanage/staytakeeffectlist/StayTakeEffectList.vue'),
        meta: {
            pageId: 21102,
            title: '转正待生效列表',
            keyword: '',
            description: ''
        },
    }, {
        path: '/company/emp/leavemanage/list',
        name: 'company_emp_leavemanage_list',
        component: () =>
            import ('./views/company/emp/leavemanage/list/List.vue'),
        meta: {
            pageId: 21103,
            title: '离职管理列表',
            keyword: '',
            description: ''
        },
    }, {
        path: '/company/emp/leavemanage/staytakeeffectlist',
        name: 'company_emp_leavemanage_staytakeeffectlist',
        component: () =>
            import ('./views/company/emp/leavemanage/staytakeeffectlist/StayTakeEffectList.vue'),
        meta: {
            pageId: 21104,
            title: '离职待生效列表',
            keyword: '',
            description: ''
        },
    }, {
        path: '/company/emp/postmanage/list',
        name: 'company_emp_postmanage_list',
        component: () =>
            import ('./views/company/emp/postmanage/list/List.vue'),
        meta: {
            pageId: 21105,
            title: '调岗管理列表',
            keyword: '',
            description: ''
        },
    }, {
        path: '/company/emp/postmanage/staytakeeffectlist',
        name: 'company_emp_postmanage_staytakeeffectlist',
        component: () =>
            import ('./views/company/emp/postmanage/staytakeeffectlist/StayTakeEffectList.vue'),
        meta: {
            pageId: 21106,
            title: '调岗待生效列表',
            keyword: '',
            description: ''
        },
    }, {
        path: '/company/emp/postmanage/history',
        name: 'company_emp_postmanage_history',
        component: () =>
            import ('./views/company/emp/postmanage/history/History.vue'),
        meta: {
            pageId: 21107,
            title: '调岗历史记录',
            keyword: '',
            description: ''
        },
    }, {
        path: '/company/emp/leavemanage/matters',
        name: 'company_emp_leavemanage_matters',
        component: () =>
            import ('./views/company/emp/leavemanage/matters/Matters.vue'),
        meta: {
            pageId: 21108,
            title: '离职事项',
            keyword: '',
            description: ''
        },
    },
    {
        path: '/company/emp/changesalarymanage/list',
        name: 'company_emp_changesalarymanage_list',
        component: () =>
            import ('./views/company/emp/changesalarymanage/list/List.vue'),
        meta: {
            pageId: 311105,
            title: '调薪管理列表',
            keyword: '',
            description: ''
        },
    },
    {
        path: '/company/emp/changesalarymanage/staytakeeffectlist',
        name: 'company_emp_changesalarymanage_staytakeeffectlist',
        component: () =>
            import ('./views/company/emp/changesalarymanage/staytakeeffectlist/Staytakeeffectlist.vue'),
        meta: {
            pageId: 311106,
            title: '调薪待生效列表',
            keyword: '',
            description: ''
        },
    },
    {
        path: '/company/emp/changesalarymanage/history',
        name: 'company_emp_changesalarymanage_history',
        component: () =>
            import ('./views/company/emp/changesalarymanage/history/History.vue'),
        meta: {
            pageId: 311107,
            title: '调薪历史记录',
            keyword: '',
            description: ''
        },
    },
    {
        path: '/company/emp/changesalarymanage/tiaoxin',
        name: 'company_emp_tiaoxin',
        component: () =>
            import ('./views/company/emp/changesalarymanage/tiaoxin2.0/Tiaoxin.vue'),
        meta: {
            pageId: 311108,
            title: '调薪申请',
            keyword: '',
            description: ''
        },
    },
    {
        path: '/common/import',
        name: 'common_import',
        component: () =>
            import ('./views/company/importcenter/import/Import.vue'),
        meta: {
            pageId: 100001,
            title: '导入',
            keyword: '',
            description: ''
        },
    },
    {
        path: '/personal/import',
        name: 'personal_import',
        component: () =>
            import ('./views/company/importcenter/import/Import.vue'),
        meta: {
            pageId: 100001,
            title: '导入',
            keyword: '',
            description: ''
        },
    },
    {
        path: '/set/common/import',
        name: 'common_import',
        component: () =>
            import ('./views/company/set/import/Import.vue'),
        meta: {
            pageId: 10000101,
            title: '导入',
            keyword: '',
            description: ''
        },
    },
    {
        path: '/company/emp/chinasoftinc/postmanage/list',
        name: 'company_emp_chinasoftinc_postmanage_list',
        component: () =>
            import ('./views/company/emp/chinasoftinc/postmanage/list/List.vue'),
        meta: {
            pageId: 22105,
            title: '调整管理列表',
            keyword: '',
            description: ''
        },
    }, {
        path: '/company/emp/chinasoftinc/postmanage/staytakeeffectlist',
        name: 'company_emp_chinasoftinc_postmanage_staytakeeffectlist',
        component: () =>
            import ('./views/company/emp/chinasoftinc/postmanage/staytakeeffectlist/StayTakeEffectList.vue'),
        meta: {
            pageId: 22106,
            title: '调整待生效列表',
            keyword: '',
            description: ''
        },
    }, {
        path: '/company/emp/chinasoftinc/postmanage/history',
        name: 'company_emp_chinasoftinc_postmanage_history',
        component: () =>
            import ('./views/company/emp/chinasoftinc/postmanage/history/History.vue'),
        meta: {
            pageId: 22107,
            title: '调整历史记录',
            keyword: '',
            description: ''
        },
    }, {
        path: '/company/emp/chinasoftinc/adjustpost',
        name: 'company_emp_chinasoftinc_adjustpost',
        component: () =>
            import ('./views/company/emp/chinasoftinc/post/Post.vue'),
        meta: {
            pageId: 22108,
            title: '调整',
            keyword: '',
            description: ''
        },
    },
    {
        path: '/company/emp/chinasoftinc/postmanage/detail',
        name: 'company_emp_chinasoftinc_postmanage_detail',
        component: () =>
            import ('./views/company/emp/chinasoftinc/postmanage/details/Details.vue'),
        meta: {
            pageId: 22112,
            title: '调整详情',
            keyword: '',
            description: ''
        },
    },
    {
        path: '/company/emp/chinasoftinc/adjust/attendance/list',
        name: 'company_emp_chinasoftinc_adjust_attendance_list',
        component: () =>
            import ('./views/company/emp/chinasoftinc/attendanceadjustment/list/List.vue'),
        meta: {
            pageId: 22110,
            title: '调整打卡权限',
            keyword: '',
            description: ''
        },
    }, {
        path: '/company/emp/chinasoftinc/adjust/attendance/history',
        name: 'company_emp_chinasoftinc_adjust_attendance_history',
        component: () =>
            import ('./views/company/emp/chinasoftinc/attendanceadjustment/history/History.vue'),
        meta: {
            pageId: 22111,
            title: '调整打卡权限',
            keyword: '',
            description: ''
        },
    }, {
        path: '/company/emp/chinasoftinc/adjust/attendance/staytakeeffectlist',
        name: 'company_emp_chinasoftinc_adjust_attendance_staytakeeffectlist',
        component: () =>
            import ('./views/company/emp/chinasoftinc/attendanceadjustment/staytakeeffectlist/StayTakeEffectList.vue'),
        meta: {
            pageId: 22113,
            title: '调整打卡权限',
            keyword: '',
            description: ''
        },
    }, {
        path: '/company/emp/chinasoftinc/adjust/attendance/editor',
        name: 'company_emp_chinasoftinc_adjust_attendance_editor',
        component: () =>
            import ('./views/company/emp/chinasoftinc/attendanceadjustment/editor/Editor.vue'),
        meta: {
            pageId: 22109,
            title: '调整打卡权限',
            keyword: '',
            description: ''
        },
    }, {
        path: '/company/emp/chinasoftinc/adjust/attendance/detail',
        name: 'company_emp_chinasoftinc_adjust_attendance_detail',
        component: () =>
            import ('./views/company/emp/chinasoftinc/attendanceadjustment/details/Details.vue'),
        meta: {
            pageId: 22109,
            title: '调整打卡权限',
            keyword: '',
            description: ''
        },
    },
    {
        path: '/company/emp/chinasoftinc/adjustmentbatchattendance/list',
        name: 'company_emp_chinasoftinc_adjust_mentbatch_attendance_list',
        component: () =>
            import ('./views/company/emp/chinasoftinc/adjustmentbatchattendance/list/List.vue'),
        meta: {
            pageId: 22201,
            title: '批量调整打卡权限',
            keyword: '',
            description: ''
        },
    }, {
        path: '/company/emp/chinasoftinc/adjustmentbatchattendance/editor',
        name: 'company_emp_chinasoftinc_adjust_mentbatch_attendance_editor',
        component: () =>
            import ('./views/company/emp/chinasoftinc/adjustmentbatchattendance/editor/Editor.vue'),
        meta: {
            pageId: 22202,
            title: '批量调整打卡权限',
            keyword: '',
            description: ''
        },
    }, {
        path: '/company/emp/chinasoftinc/adjustmentbatchattendance/staytakeeffectlist',
        name: 'company_emp_chinasoftinc_adjust_mentbatch_attendance_staytakeeffectlist',
        component: () =>
            import ('./views/company/emp/chinasoftinc/adjustmentbatchattendance/staytakeeffectlist/StayTakeEffectList.vue'),
        meta: {
            pageId: 22203,
            title: '批量调整打卡权限',
            keyword: '',
            description: ''
        },
    }, {
        path: '/company/emp/chinasoftinc/adjustmentbatchattendance/history',
        name: 'company_emp_chinasoftinc_adjust_mentbatch_attendance_history',
        component: () =>
            import ('./views/company/emp/chinasoftinc/adjustmentbatchattendance/history/History.vue'),
        meta: {
            pageId: 22204,
            title: '批量调整打卡权限',
            keyword: '',
            description: ''
        },
    },



    {
        path: '/company/emp/chinasoftincnew/postmanage/list',
        name: 'company_emp_chinasoftincnew_postmanage_list',
        component: () =>
            import ('./views/company/emp/chinasoftincnew/postmanage/list/List.vue'),
        meta: {
            pageId: 22105666,
            title: '调整管理列表考勤',
            keyword: '',
            description: ''
        },
    }, {
        path: '/company/emp/chinasoftincnew/postmanage/staytakeeffectlist',
        name: 'company_emp_chinasoftincnew_postmanage_staytakeeffectlist',
        component: () =>
            import ('./views/company/emp/chinasoftincnew/postmanage/staytakeeffectlist/StayTakeEffectList.vue'),
        meta: {
            pageId: 22106666,
            title: '调整待生效列表考勤',
            keyword: '',
            description: ''
        },
    }, {
        path: '/company/emp/chinasoftincnew/postmanage/history',
        name: 'company_emp_chinasoftincnew_postmanage_history',
        component: () =>
            import ('./views/company/emp/chinasoftincnew/postmanage/history/History.vue'),
        meta: {
            pageId: 22107666,
            title: '调整历史记录考勤',
            keyword: '',
            description: ''
        },
    }, {
        path: '/company/emp/chinasoftincnew/adjustpost',
        name: 'company_emp_chinasoftincnew_adjustpost',
        component: () =>
            import ('./views/company/emp/chinasoftincnew/post/Post.vue'),
        meta: {
            pageId: 22108666,
            title: '调整考勤',
            keyword: '',
            description: ''
        },
    },
    {
        path: '/company/emp/chinasoftincnew/postmanage/detail',
        name: 'company_emp_chinasoftincnew_postmanage_detail',
        component: () =>
            import ('./views/company/emp/chinasoftincnew/postmanage/details/Details.vue'),
        meta: {
            pageId: 22112666,
            title: '调整详情考勤',
            keyword: '',
            description: ''
        },
    },
    {
        path: '/company/emp/chinasoftincnew/adjust/attendance/list',
        name: 'company_emp_chinasoftincnew_adjust_attendance_list',
        component: () =>
            import ('./views/company/emp/chinasoftincnew/attendanceadjustment/list/List.vue'),
        meta: {
            pageId: 22110666,
            title: '调整打卡权限考勤',
            keyword: '',
            description: ''
        },
    }, {
        path: '/company/emp/chinasoftincnew/adjust/attendance/history',
        name: 'company_emp_chinasoftincnew_adjust_attendance_history',
        component: () =>
            import ('./views/company/emp/chinasoftincnew/attendanceadjustment/history/History.vue'),
        meta: {
            pageId: 22111666,
            title: '调整打卡权限考勤',
            keyword: '',
            description: ''
        },
    }, {
        path: '/company/emp/chinasoftincnew/adjust/attendance/staytakeeffectlist',
        name: 'company_emp_chinasoftincnew_adjust_attendance_staytakeeffectlist',
        component: () =>
            import ('./views/company/emp/chinasoftincnew/attendanceadjustment/staytakeeffectlist/StayTakeEffectList.vue'),
        meta: {
            pageId: 22113666,
            title: '调整打卡权限考勤',
            keyword: '',
            description: ''
        },
    }, {
        path: '/company/emp/chinasoftincnew/adjust/attendance/editor',
        name: 'company_emp_chinasoftincnew_adjust_attendance_editor',
        component: () =>
            import ('./views/company/emp/chinasoftincnew/attendanceadjustment/editor/Editor.vue'),
        meta: {
            pageId: 22109666,
            title: '调整打卡权限考勤',
            keyword: '',
            description: ''
        },
    }, {
        path: '/company/emp/chinasoftincnew/adjust/attendance/detail',
        name: 'company_emp_chinasoftincnew_adjust_attendance_detail',
        component: () =>
            import ('./views/company/emp/chinasoftincnew/attendanceadjustment/details/Details.vue'),
        meta: {
            pageId: 22109666,
            title: '调整打卡权限考勤',
            keyword: '',
            description: ''
        },
    },
    {
        path: '/company/emp/chinasoftincnew/adjustmentbatchattendance/list',
        name: 'company_emp_chinasoftincnew_adjust_mentbatch_attendance_list',
        component: () =>
            import ('./views/company/emp/chinasoftincnew/adjustmentbatchattendance/list/List.vue'),
        meta: {
            pageId: 22201666,
            title: '批量调整打卡权限考勤',
            keyword: '',
            description: ''
        },
    }, {
        path: '/company/emp/chinasoftincnew/adjustmentbatchattendance/editor',
        name: 'company_emp_chinasoftincnew_adjust_mentbatch_attendance_editor',
        component: () =>
            import ('./views/company/emp/chinasoftincnew/adjustmentbatchattendance/editor/Editor.vue'),
        meta: {
            pageId: 22202666,
            title: '批量调整打卡权限考勤',
            keyword: '',
            description: ''
        },
    }, {
        path: '/company/emp/chinasoftincnew/adjustmentbatchattendance/staytakeeffectlist',
        name: 'company_emp_chinasoftincnew_adjust_mentbatch_attendance_staytakeeffectlist',
        component: () =>
            import ('./views/company/emp/chinasoftincnew/adjustmentbatchattendance/staytakeeffectlist/StayTakeEffectList.vue'),
        meta: {
            pageId: 22203666,
            title: '批量调整打卡权限考勤',
            keyword: '',
            description: ''
        },
    }, {
        path: '/company/emp/chinasoftincnew/adjustmentbatchattendance/history',
        name: 'company_emp_chinasoftincnew_adjust_mentbatch_attendance_history',
        component: () =>
            import ('./views/company/emp/chinasoftincnew/adjustmentbatchattendance/history/History.vue'),
        meta: {
            pageId: 22204666,
            title: '批量调整打卡权限考勤',
            keyword: '',
            description: ''
        },
    },
    {
        path: '/zhongruan/icss/import',
        name: 'icss_day_import',
        component: () =>
            import ('./views/zhongruan/icssdayimport/IcssDayImport.vue'),
        meta: {
            pageId: '90842345',
            title: '中软日报导入',
            keyword: '',
            description: ''
        }
    },
    // {
    //     path: '/emp/statistical',
    //     name: 'emp_statistical',
    //     component: () =>
    //         import ('./views/company/emp/statistical/Statistical.vue'),
    //     meta: {
    //         pageId: '20601',
    //         title: '员工统计分析',
    //         keyword: '员工统计分析',
    //         description: ''
    //     }
    // },
    {
        path: '/emp/empReport',
        name: 'emp_empReport',
        component: () =>
            import ('./views/company/emp/morreport/empreport/EmpReport.vue'),
        meta: {
            pageId: '20605',
            title: '员工概况分析',
            keyword: '员工概况分析',
            description: ''
        }
    },
    {
        path: '/emp/workReport',
        name: 'emp_workReport',
        component: () =>
            import ('./views/company/emp/morreport/empreport/WorkReport.vue'),
        meta: {
            pageId: '20606',
            title: '在职员工分析',
            keyword: '在职员工分析',
            description: ''
        }
    },
    {
        path: '/emp/leaveReport',
        name: 'emp_leaveReport',
        component: () =>
            import ('./views/company/emp/morreport/empreport/LeaveReport.vue'),
        meta: {
            pageId: '20607',
            title: '离职员工分析',
            keyword: '离职员工分析',
            description: ''
        }
    },
    {
        path: '/emp/attendanceReport',
        name: 'emp_attendanceReport',
        component: () =>
            import ('./views/company/emp/morreport/empreport/AttendanceReport.vue'),
        meta: {
            pageId: '20608',
            title: '考勤分析',
            keyword: '考勤分析',
            description: ''
        }
    },

    {
        path: '/emp/statistical/emptotal',
        name: 'emp_emptotal',
        component: () =>
            import ('./views/company/emp/statistical/emptotal/Emptotal.vue'),
        meta: {
            pageId: '20602',
            title: '员工统计报表',
            keyword: '员工统计报表',
            description: ''
        }
    },
    {
        path: '/emp/statistical/customreport',
        name: 'emp_customreport',
        component: () =>
            import ('./views/company/emp/statistical/customreport/Customreport.vue'),
        meta: {
            pageId: '20603',
            title: '员工自定义报表',
            keyword: '员工自定义报表',
            description: ''
        }
    },
    {
        path: '/payroll/statistical/customreport',
        name: 'payroll_customreport',
        component: () =>
            import ('./views/company/emp/statistical/customreport/Customreport.vue'),
        meta: {
            pageId: '206031',
            title: '薪酬自定义报表',
            keyword: '薪酬自定义报表',
            description: ''
        }
    },
    {
        path: '/emp/statistical/salarystatements',
        name: 'emp_statistical_salarystatements',
        component: () =>
            import ('./views/company/emp/statistical/salarystatements/SalaryStatements.vue'),
        meta: {
            pageId: '20604',
            title: '薪酬报表列表',
            keyword: '薪酬报表列表',
            description: ''
        }
    },
    {
        path: '/emp/statistical/allowancereport',
        name: 'emp_statistical_allowancereport',
        component: () =>
            import ('./views/company/emp/statistical/allowancereport/AllowanceReport.vue'),
        meta: {
            pageId: '20605',
            title: '津贴报表列表',
            keyword: '津贴报表列表',
            description: ''
        }
    },
    {
        path: '/company/emp/filedown/list',
        name: 'emp_filedown',
        component: () =>
            import ('./views/company/emp/filedown/list/List.vue'),
        meta: {
            pageId: 207001,
            title: '员工附件下载',
            keyword: '',
            description: ''
        },
        children: []
    }, {
        path: '/company/emp/filedown/deptselect',
        name: 'emp_deptfiledown',
        component: () =>
            import ('./views/company/emp/filedown/deptdown/DeptDown.vue'),
        meta: {
            pageId: 207003,
            title: '员工附件下载',
            keyword: '',
            description: ''
        },
        children: []
    }, {
        path: '/company/emp/filedown/records',
        name: 'emp_filedownrecords',
        component: () =>
            import ('./views/company/emp/filedown/records/Records.vue'),
        meta: {
            pageId: 207002,
            title: '员工附件下载记录',
            keyword: '',
            description: ''
        },
        children: []
    }, {
        path: '/company/emp/filedown/selecttype',
        name: 'emp_selectfiletype',
        component: () =>
            import ('./views/company/emp/filedown/selectfiletype/SelectFileType.vue'),
        meta: {
            pageId: 207004,
            title: '员工附件下载',
            keyword: '',
            description: ''
        },
        children: []
    },
    {
        path: '/commercialinsurance/index',
        name: 'commercialinsurance_index',
        component: () =>
            import ('./views/company/commercialinsurance/index/Index.vue'),
        meta: {
            pageId: 300001,
            title: '商保管理',
            keyword: '',
            description: ''
        },
    },
    {
        path: '/commercialinsurance/uninsured',
        name: 'commercialinsurance_uninsured',
        component: () =>
            import ('./views/company/commercialinsurance/uninsured/Uninsured.vue'),
        meta: {
            pageId: 300001,
            title: '查看保险计划',
            keyword: '',
            description: ''
        },
    }, {
        path: '/commercialinsurance/uninsuredlist',
        name: 'commercialinsurance_uninsuredlist',
        component: () =>
            import ('./views/company/commercialinsurance/uninsuredlist/UninsuredList.vue'),
        meta: {
            pageId: 300001,
            title: '未参保员工列表',
            keyword: '',
            description: ''
        },
    },
    {
        path: '/commercialinsurance/reduction',
        name: 'commercialinsurance_reduction',
        component: () =>
            import ('./views/company/commercialinsurance/reduction/Reduction.vue'),
        meta: {
            pageId: 300002,
            title: '商保管理减员确认',
            keyword: '',
            description: ''
        },
    }, {
        path: '/commercialinsurance/indexattrition',
        name: 'commercialinsurance_indexattrition',
        component: () =>
            import ('./views/company/commercialinsurance/indexattrition/IndexAttrition.vue'),
        meta: {
            pageId: 3000021,
            title: '商保管理主页减员按钮确认弹框',
            keyword: '',
            description: ''
        },
    },
    {
        path: '/commercialinsurance/transfer',
        name: 'commercialinsurance_transfer',
        component: () =>
            import ('./views/company/commercialinsurance/transfer/Transfer.vue'),
        meta: {
            pageId: 300003,
            title: '商保管理异动确认',
            keyword: '',
            description: ''
        },
    },
    {
        path: '/commercialinsurance/billstatistics',
        name: 'commercialinsurance_billstatistics',
        component: () =>
            import ('./views/company/commercialinsurance/billstatistics/BillStatistics.vue'),
        meta: {
            pageId: 300004,
            title: '商保管理账单统计',
            keyword: '',
            description: ''
        },
    },
    {
        path: '/commercialinsurance/participation',
        name: 'commercialinsurance_participation',
        component: () =>
            import ('./views/company/commercialinsurance/participation/Participation.vue'),
        meta: {
            pageId: 300005,
            title: '商保管理参保变更',
            keyword: '',
            description: ''
        },
    }, {
        path: '/company/set/empset/basicset',
        name: 'empset_basicset',
        component: () =>
            import ('./views/company/set/empset/basicset/BasicSet.vue'),
        meta: {
            pageId: 10002,
            title: '员工基本信息设置',
            keyword: '设置',
            description: '员工基本信息设置'
        },
    }, {
        path: '/company/set/empset/recordset',
        name: 'empset_recordset',
        component: () =>
            import ('./views/company/set/empset/recordset/RecordSet.vue'),
        meta: {
            pageId: 10002,
            title: '员工档案信息设置',
            keyword: '设置',
            description: '员工档案信息设置'
        },
    }, 
    // {
    //     path: '/company/orginfo/orglist',
    //     name: 'orginfo_orglist',
    //     component: () =>
    //         import ('./views/company/orginfo/orglist/OrgList.vue'),
    //     meta: {
    //         pageId: 10002,
    //         title: '组织结构',
    //         keyword: '组织',
    //         description: '组织结构'
    //     },
    // }
    {
        path: '/company/orginfo/orglist',
        name: 'orginfo_orglist',
        component: () =>
            import ('./views/company/orginfo/mororglist/MorOrgList.vue'),
        meta: {
            pageId: 10002,
            title: '组织结构',
            keyword: '组织',
            description: '组织结构'
        },
    }
    ,{
    	path: '/company/orginfo/sortlist',
        name: 'orginfo_sortList',
        component: () =>
            import ('./views/company/orginfo/sortlist/SortList.vue'),
        meta: {
            pageId: 1000222222,
            title: '部门排序',
            keyword: '部门排序',
            description: '部门排序'
        },
    },    
    {
        path: '/company/orginfo/orgview',
        name: 'orginfo_orgview',
        component: () =>
            import ('./views/company/orginfo/orgview/OrgView.vue'),
        meta: {
            pageId: 10008,
            title: '组织结构视图',
            keyword: '组织',
            description: '组织结构视图'
        },
    }, {
        path: '/company/orginfo/postset',
        name: 'orginfo_postset',
        component: () =>
            import ('./views/company/orginfo/postset/PostSet.vue'),
        meta: {
            pageId: 10008,
            title: '岗位设置',
            keyword: '岗位',
            description: '岗位设置'
        },
    }, {
        path: '/company/orginfo/roleset',
        name: 'orginfo_roleset',
        component: () =>
            import ('./views/company/orginfo/roleset/RoleSet.vue'),
        meta: {
            pageId: 10008,
            title: '部门审批人',
            keyword: '部门审批人',
            description: '部门审批人'
        },
    }, {
        path: '/contractmodule/index',
        name: 'contractmodule_index',
        component: () =>
            import ('./views/company/contractmodule/index/Index.vue'),
        meta: {
            pageId: 60001,
            title: '合同列表',
            keyword: '合同',
            description: '合同签订'
        },
    }, {
        path: '/contractmodule/onesign',
        name: 'contractmodule_onesign',
        component: () =>
            import ('./views/company/contractmodule/onesign/OneSign.vue'),
        meta: {
            pageId: 600011,
            title: '在职员工签订',
            keyword: '合同',
            description: '合同签订'
        },
    }, {
        path: '/contractmodule/sumsign',
        name: 'contractmodule_sumsign',
        component: () =>
            import ('./views/company/contractmodule/sumsign/SumSign.vue'),
        meta: {
            pageId: 600012,
            title: '批量签订',
            keyword: '合同',
            description: '批量合同签订'
        },
    }, {
        path: '/contractmodule/renewalortermination',
        name: 'contractmodule_renewalortermination',
        component: () =>
            import ('./views/company/contractmodule/renewalortermination/RenewalOrTermination.vue'),
        meta: {
            pageId: 60002,
            title: '合同续签或终止列表',
            keyword: '合同',
            description: '合同续签或终止'
        },
    }, {
        path: '/contractmodule/renewal',
        name: 'contractmodule_renewal',
        component: () =>
            import ('./views/company/contractmodule/renewal/Renewal.vue'),
        meta: {
            pageId: 600021,
            title: '合同续签',
            keyword: '合同',
            description: '合同续签'
        },
    }, {
        path: '/contractmodule/termination',
        name: 'contractmodule_termination',
        component: () =>
            import ('./views/company/contractmodule/termination/Termination.vue'),
        meta: {
            pageId: 600022,
            title: '合同终止',
            keyword: '合同',
            description: '合同续签'
        },
    }, {
        path: '/contractmodule/changeorrelease',
        name: 'contractmodule_changeorrelease',
        component: () =>
            import ('./views/company/contractmodule/changeorrelease/ChangeOrRelease.vue'),
        meta: {
            pageId: 60003,
            title: '合同变更或解除列表',
            keyword: '合同',
            description: '合同变更或解除'
        },
    }, {
        path: '/contractmodule/change',
        name: 'contractmodule_change',
        component: () =>
            import ('./views/company/contractmodule/change/Change.vue'),
        meta: {
            pageId: 600031,
            title: '合同变更',
            keyword: '合同',
            description: '合同变更'
        },
    }, {
        path: '/contractmodule/release',
        name: 'contractmodule_release',
        component: () =>
            import ('./views/company/contractmodule/release/Release.vue'),
        meta: {
            pageId: 600032,
            title: '合同解除',
            keyword: '合同',
            description: '合同解除'
        },
    }, {
        path: '/contractmodule/modify',
        name: 'contractmodule_modify',
        component: () =>
            import ('./views/company/contractmodule/modify/Modify.vue'),
        meta: {
            pageId: 60004,
            title: '合同修改列表',
            keyword: '合同',
            description: '合同修改'
        },
    }, {
        path: '/contractmodule/edit',
        name: 'contractmodule_edit',
        component: () =>
            import ('./views/company/contractmodule/edit/Edit.vue'),
        meta: {
            pageId: 600041,
            title: '合同修改',
            keyword: '合同',
            description: '合同修改'
        },
    }, {
        path: '/contractmodule/detailed',
        name: 'contractmodule_detailed',
        component: () =>
            import ('./views/company/contractmodule/detailed/Detailed.vue'),
        meta: {
            pageId: 60005,
            title: '合同明细',
            keyword: '合同',
            description: '合同明细'
        },
    }, {
        path: '/contractmodule/seedetailed',
        name: 'contractmodule_seedetailed',
        component: () =>
            import ('./views/company/contractmodule/seedetailed/SeeDetailed.vue'),
        meta: {
            pageId: 600051,
            title: '查看合同明细',
            keyword: '合同',
            description: '查看合同明细'
        },
    }, {
        path: '/contractmodule/apply',
        name: 'contractmodule_apply',
        component: () =>
            import ('./views/company/contractmodule/apply/Apply.vue'),
        meta: {
            pageId: 60006,
            title: '合同申请',
            keyword: '合同',
            description: '合同申请'
        },
    }, {
        path: '/contractmodule/seeapply',
        name: 'contractmodule_seeapply',
        component: () =>
            import ('./views/company/contractmodule/seeapply/SeeApply.vue'),
        meta: {
            pageId: 60006,
            title: '查看合同申请',
            keyword: '合同',
            description: '查看合同申请'
        },
    }, {
        path: '/contractmodule/seal',
        name: 'contractmodule_seal',
        component: () =>
            import ('./views/company/contractmodule/seal/Seal.vue'),
        meta: {
            pageId: 60007,
            title: '合同盖章',
            keyword: '合同',
            description: '合同盖章'
        },
    }, {
        path: '/company/contractmodule/sealconfirm',
        name: 'contractmodule_sealconfirm',
        component: () =>
            import ('./views/company/contractmodule/sealconfirm/SealConfirm.vue'),
        meta: {
            pageId: 60007,
            title: '盖章人信息确认',
            keyword: '盖章人信息确认',
            description: '盖章人信息确认'
        },
    },
    {
        path: '/contractmodule/sealdetail',
        name: 'contractmodule_sealdetail',
        component: () =>
            import ('./views/company/contractmodule/sealdetail/SealDetail.vue'),
        meta: {
            pageId: 600071,
            title: '合同盖章详情',
            keyword: '合同',
            description: '合同盖章详情'
        },
    },
    {
        path: '/contractmodule/sealdetailgz',
        name: 'contractmodule_sealdetailgz',
        component: () =>
            import ('./views/company/contractmodule/sealdetailgz/SealDetail.vue'),
        meta: {
            pageId: 6000711,
            title: '合同盖章详情',
            keyword: '企业盖章',
            description: '合同盖章详情'
        },
    },
    {
        path: '/contractmodule/sealcompany',
        name: 'contractmodule_sealcompany',
        component: () =>
            import ('./views/company/contractmodule/sealcompany/SealCompany.vue'),
        meta: {
            pageId: 600072,
            title: '合同盖章合同文件详情',
            keyword: '合同',
            description: '合同盖章合同文件详情'
        },
    }, {
        path: '/company/set/contract/index',
        name: 'contractset_index',
        component: () =>
            import ('./views/company/set/contract/index/Index.vue'),
        meta: {
            pageId: 600073,
            title: '合同设置',
            keyword: '合同设置',
            description: '合同设置'
        },
    },
    {
        path: '/company/set/contract/templibrary/addmoban',
        name: 'addmoban',
        component: () =>
            import ('./views/company/set/contract/templibrary/addmoban/AddMoban.vue'),
        meta: {
            pageId: 600075,
            title: '新增模板',
            keyword: '新增模板',
            description: '新增模板'
        },
    },
    {
        path: '/company/set/contract/templibrary/lookaddmoban',
        name: 'addmoban',
        component: () =>
            import ('./views/company/set/contract/templibrary/lookaddmoban/LookAddMoban.vue'),
        meta: {
            pageId: 6000755,
            title: '查看新增模板',
            keyword: '查看新增模板',
            description: '查看新增模板'
        },
    },
    {
        path: '/company/set/contract/templibrary/addproof',
        name: 'addmoban',
        component: () =>
            import ('./views/company/set/contract/templibrary/addproof/AddProof.vue'),
        meta: {
            pageId: 600076,
            title: '新增证明模板',
            keyword: '新增证明模板',
            description: '新增证明模板'
        },
    },
    {
        path: '/company/set/contract/templibrary/lookaddproof',
        name: 'addmoban',
        component: () =>
            import ('./views/company/set/contract/templibrary/lookaddproof/LookAddProof.vue'),
        meta: {
            pageId: 6000766,
            title: '查看新增证明模板',
            keyword: '查看新增证明模板',
            description: '查看新增证明模板'
        },
    },
    {
        path: '/company/set/contract/templibrary/tempfieldset',
        name: 'addmoban',
        component: () =>
            import ('./views/company/set/contract/templibrary/tempfieldset/TempFieldSet.vue'),
        meta: {
            pageId: 6000767,
            title: '模板对应字段标签',
            keyword: '模板对应字段标签',
            description: '模板对应字段标签'
        },
    },
    {
        path: '/company/set/contract/templibrary/tempmodeset',
        name: 'addmoban',
        component: () =>
            import ('./views/company/set/contract/templibrary/tempmodeset/TempModeSet.vue'),
        meta: {
            pageId: 6000768,
            title: '配置模板',
            keyword: '配置模板',
            description: '配置模板'
        },
    },
    {
        path: '/company/set/contract/templibrary/index',
        name: 'templibrary_index',
        component: () =>
            import ('./views/company/set/contract/templibrary/index/Index.vue'),
        meta: {
            pageId: 6000773,
            title: '模板库设置',
            keyword: '模板库设置',
            description: '模板库设置'
        },
    },
    {
        path: '/company/set/contract/numrule/numrulelist',
        name: 'numrule_index',
        component: () =>
            import ('./views/company/set/contract/numrule/numrulelist/NumruleList.vue'),
        meta: {
            pageId: 6000774,
            title: '合同编号规则设置',
            keyword: '合同编号规则设置',
            description: '合同编号规则设置'
        },
    },
    {
        path: '/company/set/contract/yinzhang/list',
        name: 'yinzhang',
        component: () =>
            import ('./views/company/set/contract/yinzhang/list/List.vue'),
        meta: {
            pageId: 600077771,
            title: '印章管理',
            keyword: '印章管理',
            description: '印章管理'
        },
    },
    {
        path: '/company/set/contract/yinzhang/yinzhangmodel',
        name: 'yinzhangmodel',
        component: () =>
            import ('./views/company/set/contract/yinzhang/yinzhangmodel/YinzhangModel.vue'),
        meta: {
            pageId: 6000777711,
            title: '印章模板',
            keyword: '印章模板',
            description: '印章模板'
        },
    },
    {
        path: '/company/set/contract/realname/list',
        name: 'realname',
        component: () =>
            import ('./views/company/set/contract/realname/list/List.vue'),
        meta: {
            pageId: 600077772,
            title: '实名认证管理',
            keyword: '实名认证管理',
            description: '实名认证管理'
        },
    },
    {
        path: '/company/set/contract/sealmanagement/list',
        name: 'sealmanagement',
        component: () =>
            import ('./views/company/set/contract/sealmanagement/list/List.vue'),
        meta: {
            pageId: 600077773,
            title: '盖章人管理',
            keyword: '盖章人管理',
            description: '盖章人管理'
        },
    },
    {
        path: '/company/contractmodule/hadsigned/hadsignedlist',
        name: 'hadsigned',
        component: () =>
            import ('./views/company/contractmodule/hadsigned/hadsignedlist/List.vue'),
        meta: {
            pageId: 6000733,
            title: '已签订合同',
            keyword: '已签合同',
            description: '已签合同'
        },
    },
    {
        path: '/company/contractmodule/hadsigned/hadsignedlistsoon',
        name: 'hadsignedlistsoon',
        component: () =>
            import ('./views/company/contractmodule/hadsigned/hadsignedlistsoon/SoonList.vue'),
        meta: {
            pageId: 6000734,
            title: '即将到期合同',
            keyword: '即将到期合同',
            description: '即将到期合同'
        },
    },
    {
        path: '/company/contractmodule/contractlist/list',
        name: 'hadsigned',
        component: () =>
            import ('./views/company/contractmodule/contractlist/list/List.vue'),
        meta: {
            pageId: 60000073,
            title: '签订记录',
            keyword: '签订记录',
            description: '签订记录'
        },
    },
    {
        path: '/company/contractmodule/companyseal/list',
        name: 'hadsigned',
        component: () =>
            import ('./views/company/contractmodule/companyseal/list/List.vue'),
        meta: {
            pageId: 60000073,
            title: '企业盖章',
            keyword: '企业盖章',
            description: '企业盖章'
        },
    },
    {
        path: '/company/set/contract/legalperson',
        name: 'contractset_legalperson',
        component: () =>
            import ('./views/company/set/contract/legalperson/LegalPerson.vue'),
        meta: {
            pageId: 600073,
            title: '法人单位设置',
            keyword: '法人单位设置',
            description: '法人单位设置'
        },
    }, {
        path: '/company/set/contract/legalpersonadd',
        name: 'contractset_legalperson_add',
        component: () =>
            import ('./views/company/set/contract/legalpersonadd/Add.vue'),
        meta: {
            pageId: 600073,
            title: '新增法人单位',
            keyword: '新增法人单位',
            description: '新增法人单位'
        },
    }, {
        path: '/company/set/contract/legalpersonedit',
        name: 'contractset_legalperson_edit',
        component: () =>
            import ('./views/company/set/contract/legalpersonedit/Edit.vue'),
        meta: {
            pageId: 600074,
            title: '修改法人单位',
            keyword: '修改法人单位',
            description: '修改法人单位'
        },
    }, {
        path: '/company/set/contract/legalpersonsee',
        name: 'contractset_legalperson_see',
        component: () =>
            import ('./views/company/set/contract/legalpersonsee/See.vue'),
        meta: {
            pageId: 600075,
            title: '查看法人单位',
            keyword: '查看法人单位',
            description: '查看法人单位'
        },
    },
    {
        path: '/company/overtimeman/overtime',
        name: 'OverTime',
        component: () =>
            import ('./views/company/overtimeman/overtime/OverTime.vue'),
        meta: {
            pageId: 20007,
            title: '加班管理',
            keyword: '',
            description: ''
        },
    },
    {
        path: '/company/overtimeman/overtimeedit',
        name: 'OverTimeEdit',
        component: () =>
            import ('./views/company/overtimeman/overtimeedit/OverTimeEdit.vue'),
        meta: {
            pageId: 20008,
            title: '加班管理',
            keyword: '',
            description: ''
        },
    },
    {
        path: '/company/approval/additional/overtime',
        name: 'Overtimemanbatch',
        component: () =>
            import ('./views/company/approval/additional/overtime/Overtime.vue'),
        meta: {
            pageId: 200008,
            title: '加班补充信息',
            keyword: '',
            description: ''
        },
    }, {
        path: '/personal/company/approval/additional/overtime',
        name: 'Overtimemanbatch',
        component: () =>
            import ('./views/company/approval/additional/overtime/Overtime.vue'),
        meta: {
            pageId: 200008,
            title: '员工端-加班补充信息',
            keyword: '',
            description: ''
        },
    },
    {
        path: '/company/approval/additional/preoverworks',
        name: 'preoverworks_Overtimemanbatch',
        component: () =>
            import ('./views/company/approval/additional/preoverworks/PreOverWorks.vue'),
        meta: {
            pageId: 20000098,
            title: '加班补充信息',
            keyword: '',
            description: ''
        },
    }, {
        path: '/personal/approval/additional/preoverworks',
        name: 'preoverworks_per_Overtimemanbatch',
        component: () =>
            import ('./views/company/approval/additional/preoverworks/PreOverWorks.vue'),
        meta: {
            pageId: 20000099,
            title: '员工端-加班补充信息',
            keyword: '',
            description: ''
        },
    },
    {
        path: '/zhongruan/overtimemanbatch/index',
        name: 'Overtimemanbatch',
        component: () =>
            import ('./views/zhongruan/overtimemanbatch/index/Index.vue'),
        meta: {
            pageId: 200018,
            title: '延时工作/加班管理',
            keyword: '',
            description: ''
        },
    },
    {
        path: '/zhongruan/overtimemanbatch/apply',
        name: 'Overtimemanbatch',
        component: () =>
            import ('./views/zhongruan/overtimemanbatch/apply/Apply.vue'),
        meta: {
            pageId: 200019,
            title: '延时工作/加班申请',
            keyword: '',
            description: ''
        },
    }, {
        path: '/zhongruan/overtimemanbatch/applyfhw',
        name: 'Overtimemanbatch_applyfhw',
        component: () =>
            import ('./views/zhongruan/overtimemanbatch/applyfhw/ApplyFHW.vue'),
        meta: {
            pageId: 200020,
            title: '延时工作/加班申请',
            keyword: '',
            description: ''
        },
    },
    {
        path: '/company/holmanage/holmanage',
        name: 'HolManage',
        component: () =>
            import ('./views/company/holmanage/holmanage/HolManage.vue'),
        meta: {
            pageId: 20009,
            title: '请假管理',
            keyword: '',
            description: ''
        },
    },
    {
        path: '/company/publicrelease/publicrelease',
        name: 'PubRelease',
        component: () =>
            import ('./views/company/publicrelease/publicrelease/PubRelease.vue'),
        meta: {
            pageId: 200091,
            title: '公出管理',
            keyword: '公出',
            description: ''
        },
    },
    {
        path: '/company/publicrelease/pubreleadetail',
        name: 'PubRelease',
        component: () =>
            import ('./views/company/publicrelease/pubreleadetail/PubReleaDetail.vue'),
        meta: {
            pageId: 200092,
            title: '公出管理详情',
            keyword: '公出',
            description: ''
        },
    },

    {
        path: '/company/holmanage/holmandetail',
        name: 'HolManDetail',
        component: () =>
            import ('./views/company/holmanage/holmandetail/HolManDetail.vue'),
        meta: {
            pageId: 20010,
            title: '假期管理',
            keyword: '',
            description: ''
        },
    },
    {
        path: '/company/daily/daily',
        name: 'Daily',
        component: () =>
            import ('./views/company/daily/daily/Daily.vue'),
        meta: {
            pageId: 20011,
            title: '考勤日报',
            keyword: '',
            description: ''
        },
    },

    {
        path: '/company/daily/dailydetail',
        name: 'DailyDetail',
        component: () =>
            import ('./views/company/daily/dailydetail/DailyDetail.vue'),
        meta: {
            pageId: 20012,
            title: '考勤日报',
            keyword: '',
            description: ''
        },
    },
    {
        path: '/zhongruan/daily/dailydetail',
        name: 'DailyDetail',
        component: () =>
            import ('./views/zhongruan/daily/dailydetail/DailyDetail.vue'),
        meta: {
            pageId: 200123,
            title: '考勤日报详情',
            keyword: '',
            description: ''
        },
    }, {
        path: '/zhongruan/daily/place/add',
        name: 'AddPlace',
        component: () =>
            import ('./views/zhongruan/daily/place/addplace/AddPlace.vue'),
        meta: {
            pageId: 200201,
            title: '新增考勤地点',
            keyword: '',
            description: ''
        },
    }, {
        path: '/zhongruan/daily/place/close',
        name: 'ClosePlace',
        component: () =>
            import ('./views/zhongruan/daily/place/closeplace/ClosePlace.vue'),
        meta: {
            pageId: 200202,
            title: '关闭考勤地点',
            keyword: '',
            description: ''
        },
    },
    {
        path: '/zhongruan/daily/place/apply',
        name: 'ApplyPlace',
        component: () =>
            import ('./views/zhongruan/daily/place/apply/Apply.vue'),
        meta: {
            pageId: 200203,
            title: '考勤地点申请',
            keyword: '',
            description: ''
        },
    }, {
        path: '/zhongruan/daily/place/applyhistory',
        name: 'ApplyHistory',
        component: () =>
            import ('./views/zhongruan/daily/place/applyhistory/ApplyHistory.vue'),
        meta: {
            pageId: 200204,
            title: '考勤地点申请历史',
            keyword: '',
            description: ''
        },
    }, {
        path: '/zhongruan/daily/place/closeapply',
        name: 'CloseApply',
        component: () =>
            import ('./views/zhongruan/daily/place/closeapply/CloseApply.vue'),
        meta: {
            pageId: 200205,
            title: '考勤地点关闭',
            keyword: '',
            description: ''
        },
    }, {
        path: '/zhongruan/daily/place/closeapplyhistory',
        name: 'CloseApplyHistory',
        component: () =>
            import ('./views/zhongruan/daily/place/closeapplyhistory/CloseApplyHistory.vue'),
        meta: {
            pageId: 200205,
            title: '考勤地点关闭',
            keyword: '',
            description: ''
        },
    },
    {
        path: '/zhongruan/idle',
        name: 'Idle',
        component: () =>
            import ('./views/zhongruan/idle/Idle.vue'),
        meta: {
            pageId: 2003766,
            title: '闲置人员管理',
            keyword: '',
            description: ''
        }
    },
    {
        path: '/company/whitelist',
        name: 'WhiteList',
        component: () =>
            import ('./views/company/whitelist/list/List.vue'),
        meta: {
            pageId: 2003767,
            title: '免核算人员',
            keyword: '',
            description: ''
        }
    },
    {
        path: '/company/whitelisthistory',
        name: 'whitelisthistory',
        component: () =>
            import ('./views/company/whitelisthistory/list/List.vue'),
        meta: {
            pageId: 200376712,
            title: '免核算人员历史报表',
            keyword: '',
            description: ''
        }
    },
    {
        path: '/company/overseasyearh/currentyear',
        name: 'WhiteList',
        component: () =>
            import ('./views/company/overseasyearh/currentyear/list/List.vue'),
        meta: {
            pageId: 20067677,
            title: '海外人员',
            keyword: '',
            description: ''
        }
    },
    {
        path: '/company/overseasyearh/historyyear',
        name: 'WhiteList',
        component: () =>
            import ('./views/company/overseasyearh/historyyear/historylist/HistoryList.vue'),
        meta: {
            pageId: 20067677777,
            title: '海外人员历史',
            keyword: '',
            description: ''
        }
    },
    {
        path: '/company/giveupYh/giveupemps',
        name: 'WhiteList',
        component: () =>
            import ('./views/company/giveupYh/giveupemps/list/List.vue'),
        meta: {
            pageId: 20068677,
            title: '放弃年假人员',
            keyword: '',
            description: ''
        }
    },
    {
        path: '/company/giveupYh/giveuphistory',
        name: 'WhiteList',
        component: () =>
            import ('./views/company/giveupYh/giveuphistory/historylist/HistoryList.vue'),
        meta: {
            pageId: 20068677777,
            title: '放弃年假历史',
            keyword: '',
            description: ''
        }
    },
    {
        path: '/company/nonedaka/list',
        name: 'nonedaka_list',
        component: () =>
            import ('./views/company/nonedaka/nonedakalist/list/List.vue'),
        meta: {
            pageId: 20068877,
            title: '免打卡人员',
            keyword: '',
            description: ''
        }
    },
    {
        path: '/company/nonedaka/history',
        name: 'nonedaka_list',
        component: () =>
            import ('./views/company/nonedaka/history/History.vue'),
        meta: {
            pageId: 20068878,
            title: '免打卡人员历史',
            keyword: '',
            description: ''
        }
    },
    {
        path: '/company/monthreport/monreport',
        name: 'MonReport',
        component: () =>
            import ('./views/company/monthreport/monreport/MonReport.vue'),
        meta: {
            pageId: 20013,
            title: '考勤月报',
            keyword: '',
            description: ''
        },
    },

    {
        path: '/company/monthreport/edit',
        name: 'Edit',
        component: () =>
            import ('./views/company/monthreport/edit/Edit.vue'),
        meta: {
            pageId: 20014,
            title: '考勤月报',
            keyword: '',
            description: ''
        },
    },
    {
        path: '/company/monthreport/history',
        name: 'moth_history',
        component: () =>
            import ('./views/company/monthreport/history/History.vue'),
        meta: {
            pageId: 20015,
            title: '考勤月报',
            keyword: '',
            description: ''
        },
    },
    {
        path: '/company/monthreport/monreportdetail',
        name: 'MonReportDetail',
        component: () =>
            import ('./views/company/monthreport/monreportdetail/MonReportDetail.vue'),
        meta: {
            pageId: 20016,
            title: '考勤月报',
            keyword: '',
            description: ''
        },
    },
    {
        path: '/month/import',
        name: 'moth_import',
        component: () =>
            import ('./views/company/monthreport/import/Import.vue'),
        meta: {
            pageId: 100051,
            title: '导入',
            keyword: '',
            description: ''
        },
    },
    {
        path: '/company/monthreport/selectfile',
        name: 'Edit',
        component: () =>
            import ('./views/company/monthreport/selectfile/SelectFile.vue'),
        meta: {
            pageId: 2001444,
            title: '月报归档',
            keyword: '',
            description: ''
        },
    },
    {
        path: '/zhongruan/monthreport/monreport',
        name: 'MonReport',
        component: () =>
            import ('./views/zhongruan/monthreport/monreport/MonReport.vue'),
        meta: {
            pageId: 2001344,
            title: '非华为考勤月报',
            keyword: '',
            description: ''
        },
    },
    {
        path: '/zhongruan/monthreport/manual',
        name: 'MonReport',
        component: () =>
            import ('./views/zhongruan/monthreport/manual/Manual.vue'),
        meta: {
            pageId: 20013443,
            title: '手工考勤',
            keyword: '',
            description: ''
        },
    },
    {
        path: '/zhongruan/monthreport/history',
        name: 'Icc_history',
        component: () =>
            import ('./views/zhongruan/monthreport/history/History.vue'),
        meta: {
            pageId: 2001511,
            title: ' 非华为归档月报',
            keyword: '',
            description: ''
        },
    },

    {
        path: '/zhongruan/monthreport/edit',
        name: 'Edit',
        component: () =>
            import ('./views/zhongruan/monthreport/edit/Edit.vue'),
        meta: {
            pageId: 20014,
            title: '修改',
            keyword: '',
            description: ''
        },
    },
    {
        path: '/zhongruan/monthreport/monreport1',
        name: 'MonReport1',
        component: () =>
            import ('./views/zhongruan/monthreport1/monreport/MonReport.vue'),
        meta: {
            pageId: 2001354,
            title: '华为考勤月报',
            keyword: '',
            description: ''
        },
    }, {
        path: '/zhongruan/monthreport/annualleaverestpoolreport',
        name: 'AnnualLeaveRestPoolReport',
        component: () =>
            import ('./views/zhongruan/monthreport/annualleaverestpoolreport/AnnualLeaveRestPoolReport.vue'),
        meta: {
            pageId: 2001356,
            title: '假期池统计',
            keyword: '',
            description: ''
        },
    },
    {
        path: '/zhongruan/monthreport1/history',
        name: 'Icc1_history',
        component: () =>
            import ('./views/zhongruan/monthreport1/history/History.vue'),
        meta: {
            pageId: 20015112,
            title: '华为归档月报',
            keyword: '',
            description: ''
        },
    },
    {
        path: '/zhongruan/monthreport1/edit',
        name: 'Edit1',
        component: () =>
            import ('./views/zhongruan/monthreport1/edit/Edit.vue'),
        meta: {
            pageId: 2001455,
            title: '修改',
            keyword: '',
            description: ''
        },
    },

    {
        path: '/zhongruan/monthreport/finalfile',
        name: 'moth_finalfile',
        component: () =>
            import ('./views/zhongruan/monthreport/finalfile/FinalFile.vue'),
        meta: {
            pageId: 2001543,
            title: '月报定稿',
            keyword: '',
            description: ''
        },
    },

    {
        path: '/zhongruan/monthreport/monreportdetail',
        name: 'MonReportDetail',
        component: () =>
            import ('./views/zhongruan/monthreport/monreportdetail/MonReportDetail.vue'),
        meta: {
            pageId: 20016,
            title: '考勤月报',
            keyword: '',
            description: ''
        },
    },
    {
        path: '/zhongruan/monthreport1/monreportdetail',
        name: 'MonReportDetail',
        component: () =>
            import ('./views/zhongruan/monthreport1/monreportdetail/MonReportDetail.vue'),
        meta: {
            pageId: 20016,
            title: '考勤月报',
            keyword: '',
            description: ''
        },
    },
    {
        path: '/company/holpool/newyear',
        name: 'NewYear',
        component: () =>
            import ('./views/company/holpool/newyear/newyear/NewYear.vue'),
        meta: {
            pageId: 20017,
            title: '年假池管理',
            keyword: '',
            description: ''
        },
    },
    {
        path: '/company/holpool/newyear/newyeardetail',
        name: 'NewYearDetail',
        component: () =>
            import ('./views/company/holpool/newyear/newyeardetail/NewYearDetail.vue'),
        meta: {
            pageId: 2001711,
            title: '查看',
            keyword: '',
            description: ''
        },
    },
    {
        path: '/company/holpool/dayoff',
        name: 'DayOff',
        component: () =>
            import ('./views/company/holpool/dayoff/dayoff/DayOff.vue'),
        meta: {
            pageId: 20018,
            title: '调休池管理',
            keyword: '',
            description: ''
        },
    },
    {
        path: '/zhongruan/holpool/dayoff',
        name: 'DayOff1',
        component: () =>
            import ('./views/zhongruan/holpool/dayoff/dayoff/DayOff.vue'),
        meta: {
            pageId: 20018,
            title: '调休池管理',
            keyword: '',
            description: ''
        },
    },
    {
        path: '/company/holpool/sickhol',
        name: 'SickHol',
        component: () =>
            import ('./views/company/holpool/sickhol/sickhol/SickHol.vue'),
        meta: {
            pageId: 20019,
            title: '带薪病假池管理',
            keyword: '',
            description: ''
        },
    },
    {
        path: '/company/overtimeman/overtimedetail',
        name: 'OverTimeDetail',
        component: () =>
            import ('./views/company/overtimeman/overtimedetail/OverTimeDetail.vue'),
        meta: {
            pageId: 2020,
            title: '加班管理',
            keyword: '',
            description: ''
        },
    },
    {
        path: '/company/holpool/newyearedit',
        name: 'NewYearEdit',
        component: () =>
            import ('./views/company/holpool/newyear/newyearedit/NewYearEdit.vue'),
        meta: {
            pageId: 20021,
            title: '年假池管理',
            keyword: '',
            description: ''
        },
    },
    {
        path: '/company/holpool/newyear/history',
        name: 'newyear_history',
        component: () =>
            import ('./views/company/holpool/newyear/history/History.vue'),
        meta: {
            pageId: 20022,
            title: '已清零年假',
            keyword: '',
            description: ''
        },
    },
    {
        path: '/company/holpool/dayoff/history',
        name: 'dayoff_history',
        component: () =>
            import ('./views/company/holpool/dayoff/history/History.vue'),
        meta: {
            pageId: 20023,
            title: '已清零调休',
            keyword: '',
            description: ''
        },
    },
    {
        path: '/company/holpool/sickhol/history',
        name: 'sickhol_history',
        component: () =>
            import ('./views/company/holpool/sickhol/history/History.vue'),
        meta: {
            pageId: 20024,
            title: '已清零带薪病假',
            keyword: '',
            description: ''
        },
    },
    {
        path: '/company/holpool/newyear/calculate',
        name: 'newyear_calculate',
        component: () =>
            import ('./views/company/holpool/newyear/calculate/Calculate.vue'),
        meta: {
            pageId: 20025,
            title: '年假计算',
            keyword: '假期',
            description: '年假计算'
        },
    },
    {
        path: '/company/holpool/newyear/clear',
        name: 'newyear_clear',
        component: () =>
            import ('./views/company/holpool/newyear/clear/Clear.vue'),
        meta: {
            pageId: 20026,
            title: '年假清零',
            keyword: '假期',
            description: '年假清零'
        },
    },
    {
        path: '/company/holpool/dayoff/clear',
        name: 'dayoff_clear',
        component: () =>
            import ('./views/company/holpool/dayoff/clear/Clear.vue'),
        meta: {
            pageId: 20027,
            title: '调休清零',
            keyword: '假期',
            description: '调休清零'
        },
    },
    {
        path: '/zhongruan/holpool/dayoff/clear',
        name: 'dayoff_clear1',
        component: () =>
            import ('./views/zhongruan/holpool/dayoff/clear/Clear.vue'),
        meta: {
            pageId: 20027,
            title: '调休清零',
            keyword: '假期',
            description: '调休清零'
        },
    },

    {
        path: '/company/holpool/sickhol/calculate',
        name: 'sickhol_calculate',
        component: () =>
            import ('./views/company/holpool/sickhol/calculate/Calculate.vue'),
        meta: {
            pageId: 20028,
            title: '带薪病假计算',
            keyword: '假期',
            description: '带薪病假计算'
        },
    },
    {
        path: '/company/holpool/sickhol/clear',
        name: 'sickhol_clear',
        component: () =>
            import ('./views/company/holpool/sickhol/clear/Clear.vue'),
        meta: {
            pageId: 20029,
            title: '带薪病假清零',
            keyword: '假期',
            description: '带薪病假清零'
        },
    },
    {
        path: '/company/attstatic/attstatic',
        name: 'AttStatic',
        component: () =>
            import ('./views/company/attstatic/attstatic/AttStatic.vue'),
        meta: {
            pageId: 20030,
            title: '考勤统计',
            keyword: '',
            description: ''
        },
    },
    {
        path: '/company/attstatic/attstaticdetail',
        name: 'AttStaticD',
        component: () =>
            import ('./views/company/attstatic/attstaticdetail/AttStaticD.vue'),
        meta: {
            pageId: 20031,
            title: '考勤统计详情',
            keyword: '',
            description: ''
        },
    },
    {
        path: '/company/attstatic/custom',
        name: 'Custom',
        component: () =>
            import ('./views/company/attstatic/custom/Custom.vue'),
        meta: {
            pageId: 20032,
            title: '考勤统计',
            keyword: '自定义',
            description: ''
        },
    },
    {
        path: '/company/loan/loan',
        name: 'Loan',
        component: () =>
            import ('./views/company/loan/loan/Loan.vue'),
        meta: {
            pageId: 20033,
            title: '借调管理',
            keyword: '借调',
            description: ''
        },
    },
    {
        path: '/company/loan/loanemp',
        name: 'LoanEmp',
        component: () =>
            import ('./views/company/loan/loanemp/LoanEmp.vue'),
        meta: {
            pageId: 20034,
            title: '借调',
            keyword: '借调',
            description: ''
        },
    },
    {
        path: '/company/schedul/schedul',
        name: 'Schedul',
        component: () =>
            import ('./views/company/schedul/schedul/Schedul.vue'),
        meta: {
            pageId: 20035,
            title: '排班管理',
            keyword: '排班',
            description: ''
        },
    },

    {
        path: '/company/scheduldetail/scheduldetail',
        name: 'SchedulDetail',
        component: () =>
            import ('./views/company/scheduldetail/scheduldetail/SchedulDetail.vue'),
        meta: {
            pageId: 20036,
            title: '排班明细',
            keyword: '排班明细',
            description: ''
        },
    },
    {
        path: '/company/set/approval/flowdesign',
        name: 'flowDesign',
        component: () =>
            import ('./views/company/set/approval/advanceapproval/flowdesign/FlowDesign.vue'),
        meta: {
            pageId: 202022,
            title: '审批设置',
            keyword: '设置',
            description: '审批设置'
        },
    },
    {
        path: '/company/set/approval/advanceapproval/list',
        name: 'advanceappro_list',
        component: () =>
            import ('./views/company/set/approval/advanceapproval/list/List.vue'),
        meta: {
            pageId: 202023,
            title: '审批设置列表',
            keyword: '设置',
            description: '审批设置'
        },
    },
    {
        path: '/company/set/approval/advanceapproval/flowlist',
        name: 'advanceappro_flowlist',
        component: () =>
            import ('./views/company/set/approval/advanceapproval/flowlist/FlowList.vue'),
        meta: {
            pageId: 202023,
            title: '流程列表',
            keyword: '设置',
            description: '审批设置'
        },
    },
    {
        path: '/company/set/formoperation/formlist',
        name: 'formoperation_formlist',
        component: () =>
            import ('./views/company/set/formoperation/formlist/FormList.vue'),
        meta: {
            pageId: 203000,
            title: '表单操作权限列表',
            keyword: '设置',
            description: '审批设置'
        },
    },
    {
        path: '/company/set/formoperation/formedit',
        name: 'formoperation_formedit',
        component: () =>
            import ('./views/company/set/formoperation/formedit/FormEdit.vue'),
        meta: {
            pageId: 203001,
            title: '表单操作权限修改',
            keyword: '设置',
            description: '审批设置'
        },
    },

    {
        path: '/company/set/approval/advanceapproval/addapproval',
        name: 'advanceappro_addappro',
        component: () =>
            import ('./views/company/set/approval/advanceapproval/addapproval/AddApprove.vue'),
        meta: {
            pageId: 202023,
            title: '添加审批人',
            keyword: '添加审批人',
            description: '添加审批人'
        },
    },
    {
        path: '/company/set/approval/advanceapproval/addcopy',
        name: 'advanceappro_addcopy',
        component: () =>
            import ('./views/company/set/approval/advanceapproval/addcopy/AddCopy.vue'),
        meta: {
            pageId: 202024,
            title: '添加抄送人',
            keyword: '添加抄送人',
            description: '添加抄送人'
        },
    },
    {
        path: '/company/set/approval/advanceapproval/addcondition',
        name: 'advanceappro_addcondition',
        component: () =>
            import ('./views/company/set/approval/advanceapproval/addcondition/AddCondition.vue'),
        meta: {
            pageId: 202025,
            title: '添加条件',
            keyword: '添加条件',
            description: '添加条件'
        },
    },
    {
        path: '/company/set/approval/advanceapproval/addsupp',
        name: 'advanceappro_addsupp',
        component: () =>
            import ('./views/company/set/approval/advanceapproval/addsupp/AddSupp.vue'),
        meta: {
            pageId: 202027,
            title: '添加补充信息',
            keyword: '添加补充信息',
            description: '添加补充信息'
        },
    },
    {
        path: '/company/set/approval/advanceapproval/addremind',
        name: 'advanceappro_addremind',
        component: () =>
            import ('./views/company/set/approval/advanceapproval/addremind/AddRemind.vue'),
        meta: {
            pageId: 202026,
            title: '添加撤回提醒',
            keyword: '添加撤回提醒',
            description: '添加撤回提醒'
        },
    },

    {
        path: '/company/set/approval/baseapprovalflow',
        name: 'approval_baseapprovalflow',
        component: () =>
            import ('./views/company/set/approval/baseapprovalflow/Baseapprovalflow.vue'),
        meta: {
            pageId: 202027,
            title: '基础审批',
            keyword: '基础审批',
            description: '基础审批流程'
        },
    },
    {
        path: '/error/403',
        name: 'nopromise',
        component: () =>
            import ('./views/common/nopromise/Page403.vue'),
        meta: {
            pageId: 100000,
            title: '你没有权限',
            keyword: '403',
            description: '403'
        }
    },

    {
        //
        path: '*',
        name: 'notfount',
        component: () =>
            import ('./views/common/error/Page404.vue'),
        meta: {
            pageId: 404404,
            title: '无法找到该页面',
            keyword: '404',
            description: '404'
        }
    },
    {
        path: '/company/salarymodule/deduction',
        name: 'salarymodule_deduction',
        component: () =>
            import ('./views/company/salarymodule/deduction/Deduction.vue'),
        meta: {
            pageId: 120009,
            title: '员工个税附加扣除',
            keyword: '员工个税附加扣除',
            description: '员工个税附加扣除'
        },
    },
    {
        path: '/company/salarymodule/reportform',
        name: 'salarymodule_reportform',
        component: () =>
            import ('./views/company/salarymodule/reportform/ReportForm.vue'),
        meta: {
            pageId: 1200010,
            title: '薪资报表',
            keyword: '薪资报表',
            description: '薪资报表'
        },
    },
    {
        path: '/company/salarymodule/send',
        name: 'salarymodule_send',
        component: () =>
            import ('./views/company/salarymodule/send/Send.vue'),
        meta: {
            pageId: 1200011,
            title: '工资单',
            keyword: '工资单',
            description: '工资单'
        },
    }, {
        path: '/company/salarymodule/senddetailslist',
        name: 'salarymodule_senddetailslist',
        component: () =>
            import ('./views/company/salarymodule/senddetailslist/SendDetailsList.vue'),
        meta: {
            pageId: 1200012,
            title: '工资单详情',
            keyword: '工资单详情',
            description: '工资单详情'
        },
    },
    {
        path: '/company/salarymodule/statement',
        name: 'salarymodule_statement',
        component: () =>
            import ('./views/company/salarymodule/statement/Statement.vue'),
        meta: {
            pageId: 1200013,
            title: '网银报盘',
            keyword: '网银报盘',
            description: '网银报盘'
        },
    }, {
        path: '/company/salarymodule/payroll/list',
        name: 'salarymodule_payrolllist',
        component: () =>
            import ('./views/company/salarymodule/payroll/index/Index.vue'),
        meta: {
            pageId: 1200014,
            title: '智能薪酬工资单列表',
            keyword: '智能薪酬工资单列表',
            description: '智能薪酬工资单列表'
        },
    }, {
        path: '/company/set/userman',
        name: 'UserList',
        component: () =>
            import ('./views/company/set/userman/userlist/UserList.vue'),
        meta: {
            pageId: 20028,
            title: '用户管理',
            keyword: '权限',
            description: ''
        },
    },
    {
        path: '/company/set/roleman',
        name: 'RoleList',
        component: () =>
            import ('./views/company/set/roleman/rolelist/RoleList.vue'),
        meta: {
            pageId: 20029,
            title: '角色管理',
            keyword: '权限',
            description: ''
        },
    },
    {
        path: '/company/set/account',
        name: 'AccountNum',
        component: () =>
            import ('./views/company/set/account/accountnum/AccountNum.vue'),
        meta: {
            pageId: 20030,
            title: '账号设置',
            keyword: '权限',
            description: ''
        },
    },
    {
        path: '/company/set/company',
        name: 'CompanySet',
        component: () =>
            import ('./views/company/set/company/companyset/CompanySet.vue'),
        meta: {
            pageId: 20031,
            title: '公司信息',
            keyword: '公司',
            description: ''
        },
    },
    {
        path: '/company/set/cancellation',
        name: 'CompanySet',
        component: () =>
            import ('./views/company/set/company/cancellation/Cancellation.vue'),
        meta: {
            pageId: 200311,
            title: '注销账户',
            keyword: '注销账户',
            description: ''
        },
    },
    {
        path: '/company/set/wifiset',
        name: 'WifiList',
        component: () =>
            import ('./views/company/set/wifiset/wifilist/WifiList.vue'),
        meta: {
            pageId: 200321,
            title: '考勤WiFi',
            keyword: '打卡',
            description: ''
        },
    }, {
        path: '/company/set/jobnum',
        name: 'JobList',
        component: () =>
            import ('./views/company/set/jobnum/joblist/JobList.vue'),
        meta: {
            pageId: 20032,
            title: '工号规则设置',
            keyword: '工号',
            description: ''
        },
    }, {
        path: '/company/set/proof',
        name: 'ProofList',
        component: () =>
            import ('./views/company/set/proof/prooflist/ProofList.vue'),
        meta: {
            pageId: 20033,
            title: '证明模板设置',
            keyword: '工号',
            description: ''
        },
    }, {
        path: '/company/set/importinfo',
        name: 'ImportList',
        component: () =>
            import ('./views/company/set/importinfo/importlist/ImportList.vue'),
        meta: {
            pageId: 20034,
            title: '导入信息设置',
            keyword: '导入信息',
            description: ''
        },
    }, {
        path: '/company/set/approver',
        name: 'ApproveList',
        component: () =>
            import ('./views/company/set/approver/approvlist/ApproveList.vue'),
        meta: {
            pageId: 20035,
            title: '审批人交接',
            keyword: '审批人交接',
            description: ''
        },
    }, {
        path: '/company/set/approvework',
        name: 'WorkList1',
        component: () =>
            import ('./views/company/set/approvework/appworklist/WorkList.vue'),
        meta: {
            pageId: 20035,
            title: '审批工作交接',
            keyword: '审批工作交接',
            description: ''
        },
    }, {
        path: '/company/set/custom',
        name: 'Custom',
        component: () =>
            import ('./views/company/set/custom/customlist/Custom.vue'),
        meta: {
            pageId: 20036,
            title: '自定义表设置',
            keyword: '自定义表',
            description: ''
        },
    },
    {
        path: '/company/set/insurance',
        name: 'PlanSetting',
        component: () =>
            import ('./views/company/set/insurance/PlanSetting.vue'),
        meta: {
            pageId: 180001,
            title: '商保设置',
            keyword: '商保',
            description: ''
        }
    },
    {
        path: '/company/set/insplan',
        name: 'PlanList',
        component: () =>
            import ('./views/company/set/insplan/planlist/PlanList.vue'),
        meta: {
            pageId: 180002,
            title: '计划设置',
            keyword: '计划',
            description: ''
        }
    },
    {
        path: '/company/set/insvideo',
        name: 'InsVideoList',
        component: () =>
            import ('./views/company/set/insvideo/insvideolist/InsVideoList.vue'),
        meta: {
            pageId: 1800000003,
            title: '视频赠送设置',
            keyword: '视频赠送',
            description: ''
        }
    },
    {
        path: '/company/socialsecuritymanager/socialsecuritypersonnel',
        name: 'Socialsecuritypersonnel',
        component: () =>
            import ('./views/company/socialsecuritymanager/socialsecuritypersonnel/list/List.vue'),
        meta: {
            pageId: 600000,
            title: '在职参保管理',
            keyword: '在职参保',
            description: ''
        }
    },
    {
        path: '/company/socialsecuritymanager/socialsecuritypersonnel/uninsuredpersonnel',
        name: 'uninsuredpersonne',
        component: () =>
            import ('./views/company/socialsecuritymanager/socialsecuritypersonnel/uninsuredpersonnel/uninsuredpersonnel.vue'),
        meta: {
            pageId: 600001,
            title: '未参保管理',
            keyword: '未参保',
            description: ''
        }
    },
    {
        path: '/company/socialsecuritymanager/ssdepartingemployees/list1',
        name: 'ssdepartingemployees',
        component: () =>
            import ('./views/company/socialsecuritymanager/ssdepartingemployees/list/List.vue'),
        meta: {
            pageId: 600010,
            title: '离职在保管理',
            keyword: '未参保',
            description: ''
        }
    },
    {
        path: '/company/socialsecuritymanager/socialsecuritymove/list',
        name: 'ssdepartingemployees',
        component: () =>
            import ('./views/company/socialsecuritymanager/socialsecuritymove/list/List.vue'),
        meta: {
            pageId: 600020,
            title: '异动管理',
            keyword: '异动',
            description: ''
        }
    },
    {
        path: '/company/socialsecuritymanager/ssattritionhistory/list',
        name: 'ssdepartingemployees',
        component: () =>
            import ('./views/company/socialsecuritymanager/ssattritionhistory/list/List.vue'),
        meta: {
            pageId: 600030,
            title: '减员历史',
            keyword: '减员',
            description: ''
        }
    },
    {
        path: '/company/socialsecuritymanager/socialpayable/list',
        name: 'ssdepartingemployees',
        component: () =>
            import ('./views/company/socialsecuritymanager/socialpayable/list/List.vue'),
        meta: {
            pageId: 600040,
            title: '自行申报账单',
            keyword: '自行申报账单',
            description: ''
        }
    },
    {
        path: '/company/socialsecuritymanager/paybill/list',
        name: 'ssdepartingemployees',
        component: () =>
            import ('./views/company/socialsecuritymanager/paybill/list/List.vue'),
        meta: {
            pageId: 600050,
            title: '委托申报账单',
            keyword: '委托申报账单',
            description: ''
        }
    },
    {
        path: '/company/set/socialsecurityset',
        name: 'sociallist',
        component: () =>
            import ('./views/company/set/socialsecurityset/sociallist/Sociallist.vue'),
        meta: {
            pageId: 600050,
            title: '社保设置',
            keyword: '社保设置',
            description: ''
        }
    },
    {
        path: '/company/set/socialkefu',
        name: 'sociallist',
        component: () =>
            import ('./views/company/set/socialsecurityset/socialkefu/Socialkefu.vue'),
        meta: {
            pageId: 600050,
            title: '社保客服设置',
            keyword: '社保客服设置',
            description: ''
        }
    },
    {
        path: '/company/socialsecuritymanager/inport',
        name: 'sociallist',
        component: () =>
            import ('./views/company/socialsecuritymanager/inport/Inport.vue'),
        meta: {
            pageId: 600060,
            title: '社保导入',
            keyword: '社保导入',
            description: ''
        }
    },
    {
        path: '/company/socialsecuritymanager/inportjy',
        name: 'sociallist',
        component: () =>
            import ('./views/company/socialsecuritymanager/inportjy/Inportjy.vue'),
        meta: {
            pageId: 600060,
            title: '社保减员',
            keyword: '社保减员',
            description: ''
        }
    },
    {
        path: '/company/reportline/reportline',
        name: 'ReportLine',
        component: () =>
            import ('./views/company/set/reportline/reportline/ReportLine.vue'),
        meta: {
            pageId: 20040,
            title: '汇报线管理',
            keyword: '汇报线',
            description: ''
        },
    },
    {
        path: '/company/reportline/linedetail',
        name: 'LineDetail',
        component: () =>
            import ('./views/company/set/reportline/linedetail/LineDetail.vue'),
        meta: {
            pageId: 20040,
            title: '查看汇报线关系',
            keyword: '汇报线',
            description: ''
        }
    },
    {
        path: '/company/workbench/index',
        name: 'workbench_index',
        component: () =>
            import ('./views/company/workbench/index/Index.vue'),
        meta: {
            pageId: 50040,
            title: '工作台',
            keyword: '工作台',
            description: ''
        }
    },
    // {
    //     path: '/company/workbench/indexnew',
    //     name: 'workbench_index_new',
    //     component: () =>
    //         import ('./views/company/workbench/indexnew/IndexNew.vue'),
    //     meta: {
    //         pageId: 50040,
    //         title: '工作台',
    //         keyword: '工作台',
    //         description: ''
    //     }
    // },
    {
        path: '/company/workbench/indexnew',
        name: 'workbench_index_new',
        component: () =>
            import ('./views/company/workbench/morindex/morindex.vue'),
        meta: {
            pageId: 50040,
            title: '工作台',
            keyword: '工作台',
            description: ''
        }
    },
    {
        path: '/company/workbench/index/rulelist',
        name: 'workbench_rule_list',
        component: () =>
            import ('./views/company/workbench/rulelist/RuleList.vue'),
        meta: {
            pageId: 50041,
            title: '提醒设置',
            keyword: '提醒设置',
            description: ''
        }
    },
    {
        path: '/company/workbench/index/rulelist/onjobrule',
        name: 'workbench_rule_list_onjob',
        component: () =>
            import ('./views/company/workbench/onjobrule/OnJobRule.vue'),
        meta: {
            pageId: 50041,
            title: '提醒设置',
            keyword: '提醒设置',
            description: ''
        }
    },
    {
        path: '/company/workbench/index/unusual',
        name: 'workbench_index_unusual',
        component: () =>
            import ('./views/company/workbench/unusual/Unusual.vue'),
        meta: {
            pageId: 50051,
            title: '异常人员',
            keyword: '异常人员',
            description: ''
        }
    },
    {
        path: '/company/set/schedul/schedulist',
        name: 'ScheduList',
        component: () =>
            import ('./views/company/set/schedul/schedulist/ScheduList.vue'),
        meta: {
            pageId: 20043,
            title: '排班模板设置',
            keyword: '排班模板',
            description: ''
        }
    },
    {
        path: '/month/import',
        name: 'moth_import',
        component: () =>
            import ('./views/company/monthreport/import/Import.vue'),
        meta: {
            pageId: 100051,
            title: '导入',
            keyword: '',
            description: ''
        },
    },
    {
        path: '/zhongruan/daily/daily',
        name: 'Dailys',
        component: () =>
            import ('./views/zhongruan/daily/daily/Daily.vue'),
        meta: {
            pageId: 20037885,
            title: '考勤日报',
            keyword: '',
            description: ''
        }
    },
    {
        path: '/zhongruan/set/holdayset',
        name: 'HoldayList',
        component: () =>
            import ('./views/zhongruan/set/holdayset/holdaylist/HoldayList.vue'),
        meta: {
            pageId: 200273,
            title: '请假设置',
            keyword: '请假',
            description: ''
        },
    },
    {
        path: '/zhongruan/set/overtime',
        name: 'OverList',
        component: () =>
            import ('./views/zhongruan/set/overtime/overlist/OverList.vue'),
        meta: {
            pageId: 200262,
            title: '加班设置',
            keyword: '加班',
            description: ''
        },
    },
    {
        path: '/zhongruan/set/attendance',
        name: 'AttList',
        component: () =>
            import ('./views/zhongruan/set/attendance/attendancelist/AttList.vue'),
        meta: {
            pageId: 200272,
            title: '考勤规则',
            keyword: '考勤',
            description: ''
        },
    },
    {
        path: '/common/fixedprocess',
        name: 'comp_fixed_process',
        component: () =>
            import ('./components/fixedprocess/FixedProcess.vue'),
        meta: {
            pageId: 300272,
            title: '固定自选审批流',
            keyword: '审批',
            description: ''
        },
    },
    {
        path: '/common/chooseapprover',
        name: 'comp_choose_approver',
        component: () =>
            import ('./components/choseapprover/ChoseApprover.vue'),
        meta: {
            pageId: 300272,
            title: '选择审批人',
            keyword: '审批',
            description: ''
        },
    },
    {
        path: '/company/contractmodule/elecsign/SelectEmp',
        name: 'comp_choose_approver',
        component: () =>
            import ('./views/company/contractmodule/elecsign/selectemp/SelectEmp.vue'),
        meta: {
            pageId: 300273,
            title: '选择员工',
            keyword: '选择员工',
            description: ''
        },
    },
    {
        path: '/personal/apply',
        name: 'Apply',
        component: () =>
            import ('./views/personal/apply/main/Main.vue'),
        meta: {
            pageId: 200262,
            title: '发起申请',
            keyword: '申请',
            description: ''
        },
    },
    {
        path: '/personal/apply/applyjilu',
        name: 'Apply',
        component: () =>
            import ('./views/personal/apply/applyjilu/ApplyJilu.vue'),
        meta: {
            pageId: 200263,
            title: '申请记录',
            keyword: '申请记录',
            description: ''
        },
    },
    {
        path: '/personal/apply/batchovertime',
        name: 'batchovertime',
        component: () =>
            import ('./views/personal/apply/batchovertime/BatchOvertime.vue'),
        meta: {
            pageId: 200263,
            title: '延时工作/加班',
            keyword: '延时工作/加班',
            description: ''
        },
    },
    {
        path: '/personal/apply/xiaojia',
        name: 'xiaojia',
        component: () =>
            import ('./views/personal/apply/xiaojia/Xiaojia.vue'),
        meta: {
            pageId: 200263,
            title: '销假',
            keyword: '销假',
            description: ''
        },
    },
    {
        path: '/personal/apply/xiaojialist',
        name: 'xiaojialist',
        component: () =>
            import ('./views/personal/apply/xiaojialist/Xiaojialist.vue'),
        meta: {
            pageId: 200263,
            title: '销假列表',
            keyword: '销假列表',
            description: ''
        },
    },
    {
        path: '/personal/apply/overtimerest',
        name: 'overtimerest',
        component: () =>
            import ('./views/personal/apply/overtimerest/OverTimeRest.vue'),
        meta: {
            pageId: 2002633,
            title: '夜班补休',
            keyword: '夜班补休',
            description: ''
        },
    },
    {
        path: '/personal/apply/tiaogang',
        name: 'Apply',
        component: () =>
            import ('./views/personal/apply/tiaogang/Tiaogang.vue'),
        meta: {
            pageId: 200262,
            title: '调岗申请',
            keyword: '调岗',
            description: ''
        },
    },
    {
        path: '/personal/apply/tiaoxin',
        name: 'TiaoxinApply',
        component: () =>
            import ('./views/personal/apply/tiaoxin2.0/Tiaoxin.vue'),
        meta: {
            pageId: 200262,
            title: '调薪申请',
            keyword: '调薪',
            description: ''
        },
    },
    {
        path: '/personal/apply/holiday',
        name: 'holidayapply',
        component: () =>
            import ('./views/personal/apply/holiday/Holiday.vue'),
        meta: {
            pageId: 200262,
            title: '请假申请',
            keyword: '请假',
            description: ''
        },
    },
    {
        path: '/personal/apply/gongchu',
        name: 'gongchupply',
        component: () =>
            import ('./views/personal/apply/gongchu/Gongchu.vue'),
        meta: {
            pageId: 200262,
            title: '公出申请',
            keyword: '公出',
            description: ''
        },
    },
    {
        path: '/personal/apply/overtime',
        name: 'gongchupply',
        component: () =>
            import ('./views/personal/apply/overtime/OverTime.vue'),
        meta: {
            pageId: 200262,
            title: '加班申请',
            keyword: '加班',
            description: ''
        },
    },
    {
        path: '/personal/apply/holidaydelay',
        name: 'holidaydelayapply',
        component: () =>
            import ('./views/personal/apply/holidaydelay/HolidayDelay.vue'),
        meta: {
            pageId: 200262,
            title: '年假延休申请',
            keyword: '年假延休',
            description: ''
        },
    },
    {
        path: '/personal/apply/zidingyi',
        name: 'zidingyiapply',
        component: () =>
            import ('./views/personal/apply/zidingyi/Zidingyi.vue'),
        meta: {
            pageId: 200262,
            title: '自定义申请',
            keyword: '自定义',
            description: ''
        },
    },
    {
        path: '/personal/apply/buqian',
        name: 'holidayapply',
        component: () =>
            import ('./views/personal/apply/buqian/Buqian.vue'),
        meta: {
            pageId: 200262,
            title: '补签申请',
            keyword: '补签',
            description: ''
        },
    },
    {
        path: '/personal/apply/place',
        name: 'apply_place',
        component: () =>
            import ('./views/personal/apply/place/Place.vue'),
        meta: {
            pageId: 200271,
            title: '打卡权限申请',
            keyword: '打卡权限申请',
            description: ''
        },
    },
    {
        path: '/company/set/orginset',
        name: 'OrginSet',
        component: () =>
            import ('./views/company/set/orginset/orginlist/OrginSet.vue'),
        meta: {
            pageId: 20024,
            title: '组织设置',
            keyword: '组织设置',
            description: ''
        },
    },
    {
        path: '/company/sparepost',
        name: 'Sparepost',
        component: () =>
            import ('./views/company/set/sparepost/list/List.vue'),
        meta: {
            pageId: 2002401,
            title: '备选岗位',
            keyword: '备选岗位',
            description: ''
        }
    },
    {
        path: '/company/set/attencycle',
        name: 'CycleSet',
        component: () =>
            import ('./views/company/set/attencycle/cyclelist/CycleSet.vue'),
        meta: {
            pageId: 20025,
            title: '考勤周期',
            keyword: '考勤周期',
            description: ''
        },
    },
    {
        path: '/company/set/overtime',
        name: 'OverList',
        component: () =>
            import ('./views/company/set/overtime/overlist/OverList.vue'),
        meta: {
            pageId: 20026,
            title: '加班设置',
            keyword: '加班',
            description: ''
        },
    },
    {
        path: '/company/set/attendance',
        name: 'AttList',
        component: () =>
            import ('./views/company/set/attendance/attendancelist/AttList.vue'),
        meta: {
            pageId: 20027,
            title: '考勤规则',
            keyword: '考勤规则',
            description: ''
        },
    },
    {
        path: '/company/set/attendance/addrule',
        name: 'addrule',
        component: () =>
            import ('./views/company/set/attendance/addrule/AddRules.vue'),
        meta: {
            pageId: 200271,
            title: '新增考勤规则',
            keyword: '新增考勤规则',
            description: ''
        },
    },
    {
        path: '/company/set/speciawork',
        name: 'WorkList',
        component: () =>
            import ('./views/company/set/speciawork/worklist/WorkList.vue'),
        meta: {
            pageId: 20027,
            title: '特殊工作日设置',
            keyword: '特殊工作日',
            description: ''
        },
    },
    {
        path: '/company/set/speciahol',
        name: 'HolList',
        component: () =>
            import ('./views/company/set/speciahol/hollist/HolList.vue'),
        meta: {
            pageId: 20027,
            title: '特殊节日设置',
            keyword: '特殊节日',
            description: ''
        },
    },
    {
        path: '/company/set/holdayset',
        name: 'HoldayList',
        component: () =>
            import ('./views/company/set/holdayset/holdaylist/HoldayList.vue'),
        meta: {
            pageId: 20027,
            title: '请假设置',
            keyword: '请假',
            description: ''
        },
    },
    {
        path: '/company/set/releaseset',
        name: 'ReleaseList',
        component: () =>
            import ('./views/company/set/releaseset/releaselist/ReleaseList.vue'),
        meta: {
            pageId: 20027,
            title: '公出设置',
            keyword: '公出',
            description: ''
        },
    },

    {
        path: '/company/set/location',
        name: 'LocaList',
        component: () =>
            import ('./views/company/set/location/locationlist/LocaList.vue'),
        meta: {
            pageId: 20027,
            title: '考勤地点',
            keyword: '考勤地点',
            description: ''
        },
    },
    {
        path: '/company/set/location/addlocal',
        name: 'LocaList',
        component: () =>
            import ('./views/company/set/location/addlocal/AddLocal.vue'),
        meta: {
            pageId: 200271,
            title: '新增考勤地点',
            keyword: '新增考勤地点',
            description: ''
        },
    },
    {
        path: '/company/approval/detail',
        name: 'appro_Details',
        component: () =>
            import ('./views/company/approval/details/Details.vue'),
        meta: {
            pageId: 20028,
            title: '审批详情',
            keyword: '',
            description: ''
        },
    },

    //通知必答菜单
    {
        path: '/notices/index',
        name: 'notices_index',
        component: () =>
            import ('./views/notice/main/index/Index.vue'),
        meta: {
            pageId: 110001,
            title: '通知必达',
            keyword: '',
            description: ''
        },
    },
    {
        path: '/notices/public/list',
        name: 'notices_public_list',
        component: () =>
            import ('./views/notice/publicnotice/list/List.vue'),
        meta: {
            pageId: 110002,
            title: '通知必达',
            keyword: '',
            description: ''
        },
    },
    {
        path: '/notices/public/resend',
        name: 'notices_public_resend',
        component: () =>
            import ('./views/notice/publicnotice/resend/Resend.vue'),
        meta: {
            pageId: 110003,
            title: '通知必达',
            keyword: '',
            description: ''
        },
    },
    {
        path: '/notices/public/detail/list',
        name: 'notices_public_detail_list',
        component: () =>
            import ('./views/notice/publicnotice/detaillist/DetailList.vue'),
        meta: {
            pageId: 110004,
            title: '通知必达',
            keyword: '',
            description: ''
        },
    },
    {
        path: '/notices/other/list',
        name: 'notices_other_list',
        component: () =>
            import ('./views/notice/otherapplications/list/List.vue'),
        meta: {
            pageId: 110005,
            title: '通知必达',
            keyword: '',
            description: ''
        },
    },
    {
        path: '/notices/other/detail/list',
        name: 'notices_other_detail_list',
        component: () =>
            import ('./views/notice/otherapplications/detaillist/DetailList.vue'),
        meta: {
            pageId: 110005,
            title: '通知必达',
            keyword: '',
            description: ''
        },
    },
    {
        path: '/notices/other/resend',
        name: 'notices_other_resend',
        component: () =>
            import ('./views/notice/otherapplications/resend/Resend.vue'),
        meta: {
            pageId: 110006,
            title: '通知必达',
            keyword: '',
            description: ''
        },
    },
    {
        path: '/notices/addressbook',
        name: 'notices_addressbook',
        component: () =>
            import ('./views/notice/addressbook/AddressBook.vue'),
        meta: {
            pageId: 110007,
            title: '通知必达',
            keyword: '',
            description: ''
        },
    },
    {
        path: '/notices/admin/list',
        name: 'notices_admin_list',
        component: () =>
            import ('./views/notice/admin/list/List.vue'),
        meta: {
            pageId: 110008,
            title: '通知必达',
            keyword: '',
            description: ''
        },
    },
    {
        path: '/notices/personalcenter/index',
        name: 'notices_personalcenter_index',
        component: () =>
            import ('./views/notice/personalcenter/index/Index.vue'),
        meta: {
            pageId: 110009,
            title: '通知必达',
            keyword: '',
            description: ''
        },
    },
    {
        path: '/notices/personalcenter/order',
        name: 'notices_personalcenter_order',
        component: () =>
            import ('./views/notice/personalcenter/order/Order.vue'),
        meta: {
            pageId: 110010,
            title: '通知必达',
            keyword: '',
            description: ''
        },
    },
    {
        path: '/notices/personalcenter/pay/sms',
        name: 'notices_personalcenter_pay_sms',
        component: () =>
            import ('./views/notice/personalcenter/paysms/PaySms.vue'),
        meta: {
            pageId: 110011,
            title: '通知必达',
            keyword: '',
            description: ''
        },
    },
    {
        path: '/notices/personalcenter/send/log',
        name: 'notices_personalcenter_send_log',
        component: () =>
            import ('./views/notice/personalcenter/smssendlog/SmsSendLog.vue'),
        meta: {
            pageId: 110012,
            title: '通知必达',
            keyword: '',
            description: ''
        },
    },
    {
        path: '/notices/personalcenter/invoice/history',
        name: 'notices_personalcenter_invoice_history',
        component: () =>
            import ('./views/notice/personalcenter/invoicehistory/InvoiceHistory.vue'),
        meta: {
            pageId: 110013,
            title: '通知必达',
            keyword: '',
            description: ''
        },
    },
    {
        path: '/notices/view/detail',
        name: 'notices_view_detail',
        component: () =>
            import ('./views/notice/h5/detail/Detail.vue'),
        meta: {
            pageId: 110014,
            title: '通知必达',
            keyword: '',
            description: ''
        },
    },
    {
        path: '/notices/view/pwd/index',
        name: 'notices_view_pwd_index',
        component: () =>
            import ('./views/notice/h5/password/setpwdindex/SetPwdIndex.vue'),
        meta: {
            pageId: 110015,
            title: '通知必达',
            keyword: '',
            description: ''
        },
    },
    {
        path: '/notices/view/pwd/set',
        name: 'notices_view_pwd_set',
        component: () =>
            import ('./views/notice/h5/password/setpwd/SetPwd.vue'),
        meta: {
            pageId: 110016,
            title: '通知必达',
            keyword: '',
            description: ''
        },
    },
    {
        path: '/notices/view/pwd/set/suc',
        name: 'notices_view_pwd_set_suc',
        component: () =>
            import ('./views/notice/h5/password/setpwdsuccess/SetPwdSuccess.vue'),
        meta: {
            pageId: 110017,
            title: '通知必达',
            keyword: '',
            description: ''
        },
    },
    {
        path: '/notices/view/pwd/input',
        name: 'notices_view_pwd_input',
        component: () =>
            import ('./views/notice/h5/password/inputpwd/InputPwd.vue'),
        meta: {
            pageId: 110018,
            title: '通知必达',
            keyword: '',
            description: ''
        },
    },
    {
        path: '/notices/view/pwd/forget',
        name: 'notices_view_pwd_forget',
        component: () =>
            import ('./views/notice/h5/password/forgetpwd/ForgetPwd.vue'),
        meta: {
            pageId: 110019,
            title: '通知必达',
            keyword: '',
            description: ''
        },
    },
    {
        path: '/notices/view/feedback',
        name: 'notices_view_feedback',
        component: () =>
            import ('./views/notice/h5/feedback/Feedback.vue'),
        meta: {
            pageId: 110020,
            title: '通知必达',
            keyword: '',
            description: ''
        },
    },
    {
        path: '/notices/view/index',
        name: 'notices_view_index',
        component: () =>
            import ('./views/notice/h5/index/Index.vue'),
        meta: {
            pageId: 110021,
            title: '通知必达',
            keyword: '',
            description: ''
        },
    },
    {
        path: '/notices/view/list',
        name: 'notices_view_list',
        component: () =>
            import ('./views/notice/h5/list/List.vue'),
        meta: {
            pageId: 110022,
            title: '通知必达',
            keyword: '',
            description: ''
        },
    },
    {
        path: '/notices/view/send',
        name: 'notices_view_send',
        component: () =>
            import ('./views/notice/h5/send/Send.vue'),
        meta: {
            pageId: 110023,
            title: '通知必达',
            keyword: '',
            description: ''
        },
    },
    {
        path: '/notices/import/center',
        name: 'notices_import_center',
        component: () =>
            import ('./views/notice/importcenter/import/Import.vue'),
        meta: {
            pageId: 110024,
            title: '通知必达',
            keyword: '',
            description: ''
        },
    },
    {
        path: '/company/approval/pending',
        name: 'appro_pending',
        component: () =>
            import ('./views/company/approval/pending/Pending.vue'),
        meta: {
            pageId: 11000122,
            title: '审批管理',
            keyword: '',
            description: ''
        },
    },
    {
        path: '/company/approval/adminpending',
        name: 'appro_admin_pending',
        component: () =>
            import ('./views/company/approval/adminpending/AdminPending.vue'),
        meta: {
            pageId: 11000222,
            title: '超管审批',
            keyword: '',
            description: ''
        },
    },
    {
        path: '/company/approval/batchpending',
        name: 'appro_batch_pending',
        component: () =>
            import ('./views/company/approval/batchpending/BatchPending.vue'),
        meta: {
            pageId: 11000122,
            title: '审批管理',
            keyword: '',
            description: ''
        },
    },
    {
        path: '/company/approval/history',
        name: 'appro_history',
        component: () =>
            import ('./views/company/approval/history/History.vue'),
        meta: {
            pageId: 11000123,
            title: '已审批',
            keyword: '已审批',
            description: '已审批'
        },
    },
    {
        path: '/company/approval/adminhistory',
        name: 'appro_admin_history',
        component: () =>
            import ('./views/company/approval/adminhistory/AdminHistory.vue'),
        meta: {
            pageId: 11000123,
            title: '超管审批历史',
            keyword: '超管审批历史',
            description: '超管审批历史'
        },
    },
    {
        path: '/company/emp/compensation/wage',
        name: 'salary_supplent',
        component: () =>
            import ('./views/company/emp/compensation/wage/Wage.vue'),
        meta: {
            pageId: 110030333,
            title: '定薪补充信息',
            keyword: '定薪补充信息',
            description: '定薪补充信息'
        },
    },
    {
        path: '/company/approval/leave',
        name: 'appro_custom',
        component: () =>
            import ('./views/company/approval/additional/leave/Leave.vue'),
        meta: {
            pageId: 110030333,
            title: '离职补充信息',
            keyword: '离职补充信息',
            description: '离职补充信息'
        },
    },
    {
        path: '/company/approval/adjustpost',
        name: 'appro_adjustpost',
        component: () =>
            import ('./views/company/approval/additional/adjustpost/AdjustPost.vue'),
        meta: {
            pageId: 110030333,
            title: '调岗补充信息',
            keyword: '调岗补充信息',
            description: '调岗补充信息'
        },
    },
    {
        path: '/company/approval/custom',
        name: 'appro_custom',
        component: () =>
            import ('./views/company/approval/additional/custom/Custom.vue'),
        meta: {
            pageId: 110010333,
            title: '自定义表单',
            keyword: '自定义表单',
            description: '自定义表单'
        },
    },
    {
        path: '/personal/approval/custom',
        name: 'appro_personal_custom',
        component: () =>
            import ('./views/company/approval/additional/custom/Custom.vue'),
        meta: {
            pageId: 110010333,
            title: '自定义表单',
            keyword: '自定义表单',
            description: '自定义表单'
        },
    },
    {
        path: '/personal/approval/leave',
        name: 'appro_leave_personal',
        component: () =>
            import ('./views/company/approval/additional/leave/Leave.vue'),
        meta: {
            pageId: 810030333,
            title: '离职补充信息',
            keyword: '离职补充信息',
            description: '离职补充信息'
        },
    },
    {
        path: '/personal/approval/wage',
        name: 'appro_wage_personal',
        component: () =>
            import ('./views/company/emp/compensation/wage/Wage.vue'),
        meta: {
            pageId: 810030333,
            title: '定薪补充信息',
            keyword: '定薪补充信息',
            description: '定薪补充信息'
        },
    },
    {
        path: '/personal/approval/adjustpost',
        name: 'appro_adjustpost_personal',
        component: () =>
            import ('./views/company/approval/additional/adjustpost/AdjustPost.vue'),
        meta: {
            pageId: 810030333,
            title: '调岗补充信息',
            keyword: '调岗补充信息',
            description: '调岗补充信息'
        },
    },
    {
        path: '/personal/approval/custom',
        name: 'appro_custom_personal',
        component: () =>
            import ('./views/company/approval/additional/custom/Custom.vue'),
        meta: {
            pageId: 810010333,
            title: '自定义表单',
            keyword: '自定义表单',
            description: '自定义表单'
        },
    },
    {
        path: '/company/salarymodule/choice',
        name: 'salarymodule_choice',
        component: () =>
            import ('./views/company/salarymodule/choice/Choice.vue'),
        meta: {
            pageId: 13000001,
            title: '薪酬',
            keyword: '薪酬',
            description: '薪酬'
        },
    },
    {
        path: '/company/salarymoduleold/manager',
        name: 'salarymoduleold_manager',
        component: () =>
            import ('./views/company/salarymoduleold/manager/Manager.vue'),
        meta: {
            pageId: 13000001,
            title: '薪酬列表',
            keyword: '薪酬列表',
            description: '薪酬列表'
        },
    },
    {
        path: '/company/salarymoduleold/historylist',
        name: 'salarymoduleold_historylist',
        component: () =>
            import ('./views/company/salarymoduleold/historylist/HistoryList.vue'),
        meta: {
            pageId: 13000002,
            title: '归档历史',
            keyword: '归档历史',
            description: '归档历史'
        },
    },
    {
        path: '/company/salarymoduleold/historylistdetail',
        name: 'salarymoduleold_historylistdetail',
        component: () =>
            import ('./views/company/salarymoduleold/historylistdetail/HistoryListDetail.vue'),
        meta: {
            pageId: 130000021,
            title: '归档历史详细信息',
            keyword: '归档历史详细信息',
            description: '归档历史详细信息'
        },
    },
    {
        path: '/company/salarymoduleold/reverse',
        name: 'salarymoduleold_reverse',
        component: () =>
            import ('./views/company/salarymoduleold/reverse/Reverse.vue'),
        meta: {
            pageId: 130000022,
            title: '归档历史_反归档',
            keyword: '归档历史_反归档',
            description: '归档历史_反归档'
        },
    },
    {
        path: '/company/salarymoduleold/reportform',
        name: 'salarymoduleold_reportform',
        component: () =>
            import ('./views/company/salarymoduleold/reportform/ReportForm.vue'),
        meta: {
            pageId: 13000003,
            title: '薪资报表',
            keyword: '薪资报表',
            description: '薪资报表'
        },
    },
    {
        path: '/company/salarymoduleold/accounting/one',
        name: 'salarymoduleold_reportform_one',
        component: () =>
            import ('./views/company/salarymoduleold/accounting/one/One.vue'),
        meta: {
            pageId: 13000061,
            title: '薪酬核算_人员调整',
            keyword: '薪酬核算_人员调整',
            description: '薪酬核算_人员调整'
        },
    },
    {
        path: '/company/salarymoduleold/accounting/two',
        name: 'salarymoduleold_reportform_two',
        component: () =>
            import ('./views/company/salarymoduleold/accounting/two/Two.vue'),
        meta: {
            pageId: 13000062,
            title: '薪酬核算_薪酬调整',
            keyword: '薪酬核算_薪酬调整',
            description: '薪酬核算_薪酬调整'
        },
    },
    {
        path: '/company/salarymoduleold/accounting/thr',
        name: 'salarymoduleold_reportform_thr',
        component: () =>
            import ('./views/company/salarymoduleold/accounting/thr/Thr.vue'),
        meta: {
            pageId: 13000062,
            title: '薪酬核算_薪酬计算',
            keyword: '薪酬核算_薪酬计算',
            description: '薪酬核算_薪酬计算'
        },
    },
    {
        path: '/company/salarymoduleold/accounting/fou',
        name: 'salarymoduleold_reportform_fou',
        component: () =>
            import ('./views/company/salarymoduleold/accounting/fou/Fou.vue'),
        meta: {
            pageId: 13000062,
            title: '薪酬核算_归档本月',
            keyword: '薪酬核算_归档本月',
            description: '薪酬核算_归档本月'
        },
    },
    {
        path: '/company/salarymodule/calculation',
        name: 'salarymodule_calculation',
        component: () =>
            import ('./views/company/salarymodule/calculation/Calculation.vue'),
        meta: {
            pageId: 120001,
            title: '核算',
            keyword: '核算',
            description: '核算'
        },
    }, {
        path: '/company/salarymodule/salaryaccounting',
        name: 'salarymodule_salaryaccounting',
        component: () =>
            import ('./views/company/salarymodule/salaryaccounting/SalaryAccounting.vue'),
        meta: {
            pageId: 120002,
            title: '薪酬核算',
            keyword: '薪酬核算',
            description: '薪酬核算'
        },
    }, {
        path: '/company/salarymodule/salaryfileds',
        name: 'salarymodule_salaryfileds',
        component: () =>
            import ('./views/company/salarymodule/salaryfileds/SalaryFileds.vue'),
        meta: {
            pageId: 120003,
            title: '薪酬已归档',
            keyword: '薪酬已归档',
            description: '薪酬已归档'
        },
    }, {
        path: '/company/salarymodule/historylist',
        name: 'salarymodule_historylist',
        component: () =>
            import ('./views/company/salarymodule/historylist/HistoryList.vue'),
        meta: {
            pageId: 120004,
            title: '历史薪资列表',
            keyword: '历史薪资列表',
            description: '历史薪资列表'
        },
    }, {
        path: '/company/salarymodule/dataready',
        name: 'salarymodule_dataready',
        component: () =>
            import ('./views/company/salarymodule/dataready/DataReady.vue'),
        meta: {
            pageId: 120005,
            title: '薪酬核算数据准备',
            keyword: '薪酬核算数据准备',
            description: '薪酬核算数据准备'
        },
    }, {
        path: '/company/salarymodule/dataunlist',
        name: 'salarymodule_dataunlist',
        component: () =>
            import ('./views/company/salarymodule/dataunlist/DataUnList.vue'),
        meta: {
            pageId: 120001,
            title: '薪酬核算已归档数据列表',
            keyword: '薪酬核算已归档数据列表',
            description: '薪酬核算已归档数据列表'
        },
    }, {
        path: '/company/salarymodule/datalist',
        name: 'salarymodule_datalist',
        component: () =>
            import ('./views/company/salarymodule/datalist/DataList.vue'),
        meta: {
            pageId: 120007,
            title: '薪酬核算数据列表',
            keyword: '薪酬核算数据列表',
            description: '薪酬核算数据列表'
        },
    }, {
        path: '/company/salarymodule/businessaccounting',
        name: 'salarymodule_businessaccounting',
        component: () =>
            import ('./views/company/salarymodule/businessaccounting/BusinessAccounting.vue'),
        meta: {
            pageId: 120008,
            title: '薪酬核算列表',
            keyword: '薪酬核算列表',
            description: '薪酬核算列表'
        },
    },
    {
        path: '/company/salarymodule/deduction',
        name: 'salarymodule_deduction',
        component: () =>
            import ('./views/company/salarymodule/deduction/Deduction.vue'),
        meta: {
            pageId: 120009,
            title: '员工个税附加扣除',
            keyword: '员工个税附加扣除',
            description: '员工个税附加扣除'
        },
    },
    {
        path: '/company/salarymodule/reportform',
        name: 'salarymodule_reportform',
        component: () =>
            import ('./views/company/salarymodule/reportform/ReportForm.vue'),
        meta: {
            pageId: 1200010,
            title: '薪资报表',
            keyword: '薪资报表',
            description: '薪资报表'
        },
    },
    {
        path: '/company/salarymodule/send',
        name: 'salarymodule_send',
        component: () =>
            import ('./views/company/salarymodule/send/Send.vue'),
        meta: {
            pageId: 1200011,
            title: '工资单',
            keyword: '工资单',
            description: '工资单'
        },
    }, {
        path: '/company/salarymodule/senddetailslist',
        name: 'salarymodule_senddetailslist',
        component: () =>
            import ('./views/company/salarymodule/senddetailslist/SendDetailsList.vue'),
        meta: {
            pageId: 1200012,
            title: '工资单详情',
            keyword: '工资单详情',
            description: '工资单详情'
        },
    },
    {
        path: '/company/salarymodule/statement',
        name: 'salarymodule_statement',
        component: () =>
            import ('./views/company/salarymodule/statement/Statement.vue'),
        meta: {
            pageId: 1200013,
            title: '网银报盘',
            keyword: '网银报盘',
            description: '网银报盘'
        },
    }, {
        path: '/company/set/userman',
        name: 'UserList',
        component: () =>
            import ('./views/company/set/userman/userlist/UserList.vue'),
        meta: {
            pageId: 20028,
            title: '用户管理',
            keyword: '权限',
            description: ''
        },
    },
    {
        path: '/company/set/roleman',
        name: 'RoleList',
        component: () =>
            import ('./views/company/set/roleman/rolelist/RoleList.vue'),
        meta: {
            pageId: 20029,
            title: '角色管理',
            keyword: '权限',
            description: ''
        },
    },
    {
        path: '/company/set/account',
        name: 'AccountNum',
        component: () =>
            import ('./views/company/set/account/accountnum/AccountNum.vue'),
        meta: {
            pageId: 20030,
            title: '账号设置',
            keyword: '权限',
            description: ''
        },
    },
    {
        path: '/company/set/company',
        name: 'CompanySet',
        component: () =>
            import ('./views/company/set/company/companyset/CompanySet.vue'),
        meta: {
            pageId: 20031,
            title: '公司信息',
            keyword: '公司',
            description: ''
        },
    }, {
        path: '/company/set/wifiset',
        name: 'WifiList',
        component: () =>
            import ('./views/company/set/wifiset/wifilist/WifiList.vue'),
        meta: {
            pageId: 20032,
            title: '考勤WIFI',
            keyword: '考勤WIFI',
            description: ''
        },
    }, {
        path: '/company/set/jobnum',
        name: 'JobList',
        component: () =>
            import ('./views/company/set/jobnum/joblist/JobList.vue'),
        meta: {
            pageId: 20032,
            title: '工号规则设置',
            keyword: '工号',
            description: ''
        },
    }, {
        path: '/company/set/proof',
        name: 'ProofList',
        component: () =>
            import ('./views/company/set/proof/prooflist/ProofList.vue'),
        meta: {
            pageId: 20033,
            title: '证明模板设置',
            keyword: '工号',
            description: ''
        },
    }, {
        path: '/company/set/importinfo',
        name: 'ImportList',
        component: () =>
            import ('./views/company/set/importinfo/importlist/ImportList.vue'),
        meta: {
            pageId: 20034,
            title: '导入信息设置',
            keyword: '导入信息',
            description: ''
        },
    }, {
        path: '/company/set/approver',
        name: 'ApproveList',
        component: () =>
            import ('./views/company/set/approver/approvlist/ApproveList.vue'),
        meta: {
            pageId: 20035,
            title: '审批人交接',
            keyword: '审批人交接',
            description: ''
        },
    }, {
        path: '/company/set/approvework',
        name: 'WorkList1',
        component: () =>
            import ('./views/company/set/approvework/appworklist/WorkList.vue'),
        meta: {
            pageId: 20035,
            title: '审批工作交接',
            keyword: '审批工作交接',
            description: ''
        },
    }, {
        path: '/company/set/custom',
        name: 'Custom',
        component: () =>
            import ('./views/company/set/custom/customlist/Custom.vue'),
        meta: {
            pageId: 20036,
            title: '自定义表设置',
            keyword: '自定义表',
            description: ''
        },
    },
    {
        path: '/company/set/insurance',
        name: 'PlanSetting',
        component: () =>
            import ('./views/company/set/insurance/PlanSetting.vue'),
        meta: {
            pageId: 180001,
            title: '商保设置',
            keyword: '商保',
            description: ''
        }
    },
    {
        path: '/company/set/insplan',
        name: 'PlanList',
        component: () =>
            import ('./views/company/set/insplan/planlist/PlanList.vue'),
        meta: {
            pageId: 180002,
            title: '计划设置',
            keyword: '计划',
            description: ''
        }
    },
    {
        path: '/company/set/insvideo',
        name: 'InsVideoList',
        component: () =>
            import ('./views/company/set/insvideo/insvideolist/InsVideoList.vue'),
        meta: {
            pageId: 1800000003,
            title: '视频赠送设置',
            keyword: '视频赠送',
            description: ''
        }
    },
    {
        path: '/company/socialsecuritymanager/socialsecuritypersonnel',
        name: 'Socialsecuritypersonnel',
        component: () =>
            import ('./views/company/socialsecuritymanager/socialsecuritypersonnel/list/List.vue'),
        meta: {
            pageId: 600000,
            title: '在职参保管理',
            keyword: '在职参保',
            description: ''
        }
    },
    {
        path: '/company/socialsecuritymanager/socialsecuritypersonnel/uninsuredpersonnel',
        name: 'uninsuredpersonne',
        component: () =>
            import ('./views/company/socialsecuritymanager/socialsecuritypersonnel/uninsuredpersonnel/uninsuredpersonnel.vue'),
        meta: {
            pageId: 600001,
            title: '未参保管理',
            keyword: '未参保',
            description: ''
        }
    },
    {
        path: '/company/socialsecuritymanager/ssdepartingemployees/list1',
        name: 'ssdepartingemployees',
        component: () =>
            import ('./views/company/socialsecuritymanager/ssdepartingemployees/list/List.vue'),
        meta: {
            pageId: 600010,
            title: '离职在保管理',
            keyword: '未参保',
            description: ''
        }
    },
    {
        path: '/company/socialsecuritymanager/socialsecuritymove/list',
        name: 'ssdepartingemployees',
        component: () =>
            import ('./views/company/socialsecuritymanager/socialsecuritymove/list/List.vue'),
        meta: {
            pageId: 600020,
            title: '异动管理',
            keyword: '异动',
            description: ''
        }
    },
    {
        path: '/company/socialsecuritymanager/ssattritionhistory/list',
        name: 'ssdepartingemployees',
        component: () =>
            import ('./views/company/socialsecuritymanager/ssattritionhistory/list/List.vue'),
        meta: {
            pageId: 600030,
            title: '减员历史',
            keyword: '减员',
            description: ''
        }
    },
    {
        path: '/company/socialsecuritymanager/socialpayable/list',
        name: 'ssdepartingemployees',
        component: () =>
            import ('./views/company/socialsecuritymanager/socialpayable/list/List.vue'),
        meta: {
            pageId: 600040,
            title: '自行申报账单',
            keyword: '自行申报账单',
            description: ''
        }
    },
    {
        path: '/company/socialsecuritymanager/paybill/list',
        name: 'ssdepartingemployees',
        component: () =>
            import ('./views/company/socialsecuritymanager/paybill/list/List.vue'),
        meta: {
            pageId: 600050,
            title: '委托申报账单',
            keyword: '委托申报账单',
            description: ''
        }
    },
    {
        path: '/company/set/socialsecurityset',
        name: 'sociallist',
        component: () =>
            import ('./views/company/set/socialsecurityset/sociallist/Sociallist.vue'),
        meta: {
            pageId: 600050,
            title: '社保设置',
            keyword: '社保设置',
            description: ''
        }
    },
    {
        path: '/company/set/socialkefu',
        name: 'sociallist',
        component: () =>
            import ('./views/company/set/socialsecurityset/socialkefu/Socialkefu.vue'),
        meta: {
            pageId: 600050,
            title: '社保客服设置',
            keyword: '社保客服设置',
            description: ''
        }
    },
    {
        path: '/company/socialsecuritymanager/inport',
        name: 'sociallist',
        component: () =>
            import ('./views/company/socialsecuritymanager/inport/Inport.vue'),
        meta: {
            pageId: 600060,
            title: '社保导入',
            keyword: '社保导入',
            description: ''
        }
    },
    {
        path: '/company/socialsecuritymanager/inportjy',
        name: 'sociallist',
        component: () =>
            import ('./views/company/socialsecuritymanager/inportjy/Inportjy.vue'),
        meta: {
            pageId: 600060,
            title: '社保减员',
            keyword: '社保减员',
            description: ''
        }
    },
    {
        path: '/company/set/reportline/reportline',
        name: 'ReportLine',
        component: () =>
            import ('./views/company/set/reportline/reportline/ReportLine.vue'),
        meta: {
            pageId: 20040,
            title: '汇报线管理',
            keyword: '汇报线',
            description: ''
        },
    },
    {
        path: '/company/set/reportline/linedetail',
        name: 'LineDetail',
        component: () =>
            import ('./views/company/set/reportline/linedetail/LineDetail.vue'),
        meta: {
            pageId: 20040,
            title: '查看汇报线关系',
            keyword: '汇报线',
            description: ''
        }
    },
    {
        path: '/company/workbench/index',
        name: 'workbench_index',
        component: () =>
            import ('./views/company/workbench/index/Index.vue'),
        meta: {
            pageId: 50040,
            title: '工作台',
            keyword: '工作台',
            description: ''
        }
    },
    {
        path: '/company/workbench/index/rulelist',
        name: 'workbench_rule_list',
        component: () =>
            import ('./views/company/workbench/rulelist/RuleList.vue'),
        meta: {
            pageId: 50041,
            title: '提醒设置',
            keyword: '提醒设置',
            description: ''
        }
    },
    {
        path: '/company/workbench/index/rulelist/onjobrule',
        name: 'workbench_rule_list_onjob',
        component: () =>
            import ('./views/company/workbench/onjobrule/OnJobRule.vue'),
        meta: {
            pageId: 50041,
            title: '提醒设置',
            keyword: '提醒设置',
            description: ''
        }
    },
    {
        path: '/company/workbench/index/unusual',
        name: 'workbench_index_unusual',
        component: () =>
            import ('./views/company/workbench/unusual/Unusual.vue'),
        meta: {
            pageId: 50051,
            title: '异常人员',
            keyword: '异常人员',
            description: ''
        }
    },
    {
        path: '/company/set/schedul/schedulist',
        name: 'ScheduList',
        component: () =>
            import ('./views/company/set/schedul/schedulist/ScheduList.vue'),
        meta: {
            pageId: 20043,
            title: '排班模板设置',
            keyword: '排班模板',
            description: ''
        }
    },

    {
        path: '/zhongruan/daily/daily',
        name: 'Dailys',
        component: () =>
            import ('./views/zhongruan/daily/daily/Daily.vue'),
        meta: {
            pageId: 20037885,
            title: '考勤日报',
            keyword: '',
            description: ''
        }
    },
    {
        path: '/zhongruan/set/holdayset',
        name: 'HoldayList',
        component: () =>
            import ('./views/zhongruan/set/holdayset/holdaylist/HoldayList.vue'),
        meta: {
            pageId: 200273,
            title: '请假设置',
            keyword: '请假',
            description: ''
        },
    },
    {
        path: '/zhongruan/set/overtime',
        name: 'OverList',
        component: () =>
            import ('./views/zhongruan/set/overtime/overlist/OverList.vue'),
        meta: {
            pageId: 200262,
            title: '加班设置',
            keyword: '加班',
            description: ''
        },
    },
    {
        path: '/zhongruan/set/attendance',
        name: 'AttList',
        component: () =>
            import ('./views/zhongruan/set/attendance/attendancelist/AttList.vue'),
        meta: {
            pageId: 200272,
            title: '考勤规则',
            keyword: '考勤',
            description: ''
        },
    }, {
        path: '/zhongruan/set/addlocation',
        name: 'AddLocation',
        component: () =>
            import ('./views/zhongruan/set/addlocation/AddLocation.vue'),
        meta: {
            pageId: 200273,
            title: '考勤地点采集',
            keyword: '考勤',
            description: ''
        },
    },
    {
        path: '/common/fixedprocess',
        name: 'comp_fixed_process',
        component: () =>
            import ('./components/fixedprocess/FixedProcess.vue'),
        meta: {
            pageId: 300272,
            title: '固定自选审批流',
            keyword: '审批',
            description: ''
        },
    },
    {
        path: '/personal/chooseapprover',
        name: 'comp_choose_personal_approver',
        component: () =>
            import ('./components/choseapprover/ChoseApprover.vue'),
        meta: {
            pageId: 300272,
            title: '选择审批人',
            keyword: '审批',
            description: ''
        },
    },
    {
        path: '/personal/daydetail',
        name: 'daydetail',
        component: () =>
            import ('./views/personal/attencemanager/daydetail/Index.vue'),
        meta: {
            pageId: 100051,
            title: '日考勤详情页面',
            keyword: '',
            description: ''
        },
    },
    {
        path: '/personal/monthdetail',
        name: 'monthdetail',
        component: () =>
            import ('./views/personal/attencemanager/monthdetail/Index.vue'),
        meta: {
            pageId: 100051,
            title: '月考勤详情页面',
            keyword: '',
            description: ''
        },
    },
    {
        path: '/personal/zrdaydetail',
        name: 'daydetail',
        component: () =>
            import ('./views/personal/zrattencemanager/daydetail/Index.vue'),
        meta: {
            pageId: 10005111,
            title: '日考勤详情页面',
            keyword: '',
            description: ''
        },
    },
    {
        path: '/personal/zrmonthdetail',
        name: 'monthdetail',
        component: () =>
            import ('./views/personal/zrattencemanager/monthdetail/Index.vue'),
        meta: {
            pageId: 10002251,
            title: '月考勤详情页面',
            keyword: '',
            description: ''
        },
    },
    {
        path: '/personal/zrdaydetailnew',
        name: 'daydetailnew',
        component: () =>
            import ('./views/personal/zrattencemanager/daydetailnew/Index.vue'),
        meta: {
            pageId: 10005112,
            title: '日考勤详情页面',
            keyword: '',
            description: ''
        },
    },
    {
        path: "/personal/seedakadata",
        name: "dakadata",
        component: () =>
            import ('./views/personal/zrattencemanager/dakadata/Index.vue'),
        meta: {
            pageId: 10005113,
            title: "查看打卡数据",
            keywor: "",
            description: ''
        }
    },
    {
        path: '/personal/validpwd',
        name: 'validpwd',
        component: () =>
            import ('./views/personal/wage/validpwd/Index.vue'),
        meta: {
            pageId: 100051,
            title: '工资条',
            keyword: '',
            description: ''
        },
    },
    {
        path: '/personal/findpwd',
        name: 'findpwd',
        component: () =>
            import ('./views/personal/wage/findpwd/Index.vue'),
        meta: {
            pageId: 100051,
            title: '工资条',
            keyword: '',
            description: ''
        },
    },
    {
        path: '/personal/setpwd',
        name: 'setpwd',
        component: () =>
            import ('./views/personal/wage/setpwd/Index.vue'),
        meta: {
            pageId: 100051,
            title: '工资条',
            keyword: '',
            description: ''
        },
    },
    {
        path: '/personal/sucwage',
        name: 'sucwage',
        component: () =>
            import ('./views/personal/wage/success/Index.vue'),
        meta: {
            pageId: 100051,
            title: '工资条',
            keyword: '',
            description: ''
        },
    },
    {
        path: '/personal/inputpwd',
        name: 'inputpwd',
        component: () =>
            import ('./views/personal/wage/inputpwd/Index.vue'),
        meta: {
            pageId: 100051,
            title: '工资条',
            keyword: '',
            description: ''
        },
    },

    {
        path: '/personal/wagelist',
        name: 'wagelist',
        component: () =>
            import ('./views/personal/wage/list/List.vue'),
        meta: {
            pageId: 100051,
            title: '工资条',
            keyword: '',
            description: ''
        },
    },
    {
        path: '/personal/wagedetail',
        name: 'wagedetail',
        component: () =>
            import ('./views/personal/wage/detail/Detail.vue'),
        meta: {
            pageId: 100051,
            title: '工资条详情',
            keyword: '',
            description: ''
        },
    },
    {
        path: '/personal/index',
        name: 'wagedetail',
        component: () =>
            import ('./views/personal/index/Index.vue'),
        meta: {
            pageId: 1000111111,
            title: '员工端首页',
            keyword: '',
            description: ''
        },
    }, {
        path: '/personal/notice/index',
        name: 'personal_notice_index',
        component: () =>
            import ('./views/personal/notice/index/Index.vue'),
        meta: {
            pageId: 1000111111,
            title: '员工端-公告列表',
            keyword: '',
            description: ''
        },
    }, {
        path: '/personal/message/index',
        name: 'personal_message_index',
        component: () =>
            import ('./views/personal/notice/message/Message.vue'),
        meta: {
            pageId: 1000111111,
            title: '员工端-消息列表',
            keyword: '',
            description: ''
        },
    }, {
        path: '/personal/message/staffsupplement',
        name: 'personal_message_staffsupplement',
        component: () =>
            import ('./views/personal/notice/staffsupplement/StaffSupplement.vue'),
        meta: {
            pageId: 1000111112,
            title: '员工端-消息列表',
            keyword: '',
            description: ''
        },
    },
    {
        path: '/personal/message/detail',
        name: 'personal_message_detail',
        component: () =>
            import ('./views/personal/notice/messagedetail/MessageDetail.vue'),
        meta: {
            pageId: 1000111113,
            title: '员工端-消息详情',
            keyword: '',
            description: ''
        },
    }, {
        path: '/personal/message/overtimedetail',
        name: 'personal_message_overtimedetail',
        component: () =>
            import ('./views/personal/notice/overtimedetail/OvertimeDetail.vue'),
        meta: {
            pageId: 1000111114,
            title: '员工端-延时工作/加班消息详情',
            keyword: '',
            description: ''
        },
    }, {
        path: '/personal/overtimemanbatch/index',
        name: 'Overtimemanbatch',
        component: () =>
            import ('./views/personal/overtimemanbatch/index/Index.vue'),
        meta: {
            pageId: 200018,
            title: '延时工作/加班管理',
            keyword: '',
            description: ''
        },
    },
    {
        path: '/personal/overtimemanbatch/apply',
        name: 'Overtimemanbatch',
        component: () =>
            import ('./views/personal/overtimemanbatch/apply/Apply.vue'),
        meta: {
            pageId: 2000191,
            title: '延时工作/加班申请',
            keyword: '',
            description: ''
        },
    }, {
        path: '/personal/overtimemanbatch/addapply',
        name: 'Overtimemanbatch',
        component: () =>
            import ('./views/personal/overtimemanbatch/apply/Apply.vue'),
        meta: {
            pageId: 2000192,
            title: '延时工作/加班申请',
            keyword: '',
            description: ''
        },
    }, {
        path: '/personal/overtimemanbatch/applyfhw',
        name: 'Overtimemanbatch_applyfhw',
        component: () =>
            import ('./views/personal/overtimemanbatch/applyfhw/ApplyFHW.vue'),
        meta: {
            pageId: 2000201,
            title: '延时工作/加班申请',
            keyword: '',
            description: ''
        },
    }, {
        path: '/personal/overtimemanbatch/addapplyfhw',
        name: 'Overtimemanbatch_applyfhw',
        component: () =>
            import ('./views/personal/overtimemanbatch/applyfhw/ApplyFHW.vue'),
        meta: {
            pageId: 2000202,
            title: '延时工作/加班申请',
            keyword: '',
            description: ''
        },
    },
    {
        path: '/personal/approval/pending',
        name: 'appro_personal_pending',
        component: () =>
            import ('./views/company/approval/pending/Pending.vue'),
        meta: {
            pageId: 81000122,
            title: '审批管理',
            keyword: '',
            description: ''
        },
    },
    {
        path: '/personal/approval/batchpending',
        name: 'appro_personal_batch_pending',
        component: () =>
            import ('./views/company/approval/batchpending/BatchPending.vue'),
        meta: {
            pageId: 81000122,
            title: '审批管理',
            keyword: '',
            description: ''
        },
    },
    {
        path: '/personal/approval/history',
        name: 'appro_personal_history',
        component: () =>
            import ('./views/company/approval/history/History.vue'),
        meta: {
            pageId: 81000123,
            title: '已审批',
            keyword: '已审批',
            description: '已审批'
        },
    },
    {
        path: '/personal/approval/detail',
        name: 'appro_personal_Details',
        component: () =>
            import ('./views/company/approval/details/Details.vue'),
        meta: {
            pageId: 8110028,
            title: '审批详情',
            keyword: '',
            description: ''
        },
    },
    {
        path: '/personal/leavebalance',
        name: 'LeaveBalance',
        component: () =>
            import ('./views/personal/leavebalance/leavebalance/LeaveBalance.vue'),
        meta: {
            pageId: 1000111111,
            title: '假期池',
            keyword: '',
            description: ''
        },
    },
    {
        path: '/personal/banci',
        name: 'banci',
        component: () =>
            import ('./views/personal/banci/Banci.vue'),
        meta: {
            pageId: 1000111122,
            title: '班次',
            keyword: '',
            description: ''
        },
    },
    {
        path: '/personal/dakaqx',
        name: 'dakadizhi',
        component: () =>
            import ('./views/personal/dakaqx/Dakaqx.vue'),
        meta: {
            pageId: 1000111123,
            title: '打卡地址',
            keyword: '',
            description: ''
        },
    },
    {
        path: '/personal/apply/regular',
        name: 'Regular',
        component: () =>
            import ('./views/personal/apply/regular/Regular.vue'),
        meta: {
            pageId: 1000111112,
            title: '转正申请',
            keyword: '',
            description: ''
        },
    },
    {
        path: '/personal/apply/departure',
        name: 'Departure',
        component: () =>
            import ('./views/personal/apply/departure/Departure.vue'),
        meta: {
            pageId: 1000111113,
            title: '离职申请',
            keyword: '',
            description: ''
        },
    },
    {
        path: '/company/staffbianzhi/detaillist',
        name: 'Departure',
        component: () =>
            import ('./views/company/staffbianzhi/detaillist/Detaillist.vue'),
        meta: {
            pageId: 1000111133,
            title: '编制明细',
            keyword: '',
            description: ''
        },
    },
    {
        path: '/company/staffbianzhi/tongjilist',
        name: 'Departure',
        component: () =>
            import ('./views/company/staffbianzhi/tongjilist/Tongjilist.vue'),
        meta: {
            pageId: 1000111122,
            title: '编制统计',
            keyword: '',
            description: ''
        },
    },
    {
        path: '/company/staffbianzhi/addorgan',
        name: 'AddOrgan',
        component: () =>
            import ('./views/company/staffbianzhi/addorgan/AddOrgan.vue'),
        meta: {
            pageId: 1000111118,
            title: '新增编制',
            keyword: '',
            description: ''
        },
    },
    {
        path: '/company/staffbianzhi/positiongrade/gradelist',
        name: 'GradeList',
        component: () =>
            import ('./views/company/staffbianzhi/positiongrade/gradelist/GradeList.vue'),
        meta: {
            pageId: 1000111318,
            title: '职位等级',
            keyword: '',
            description: ''
        },
    },
    {
        path: '/company/staffbianzhi/positiontype/typelist',
        name: 'GradeList',
        component: () =>
            import ('./views/company/staffbianzhi/positiontype/typelist/TypeList.vue'),
        meta: {
            pageId: 1000111418,
            title: '职位类型',
            keyword: '',
            description: ''
        },
    },
    {
        path: '/company/staffbianzhi/empgrade/empgradelist',
        name: 'GradeList',
        component: () =>
            import ('./views/company/staffbianzhi/empgrade/empgradelist/EmpgradeList.vue'),
        meta: {
            pageId: 1000111418,
            title: '员工等级',
            keyword: '',
            description: ''
        },
    }, {
        path: '/company/depttiling',
        name: 'depttiling',
        component: () =>
            import ('./components/depttiling/DeptTiling.vue'),
        meta: {
            pageId: 456789,
            title: '平铺',
            keyword: '',
            description: ''
        },
    },
    {
        path: '/company/emp/directlist',
        name: 'emp_directlist',
        component: () =>
            import ('./views/company/emp/onjob/directemplist/EmpList.vue'),
        meta: {
            pageId: 20100,
            title: '直接主管修改',
            keyword: '',
            description: ''
        },
        children: []
    },
    {
        path: '/company/emp/salaryman/list',
        name: 'salary_list',
        component: () =>
            import ('./views/company/emp/salaryman/list/List.vue'),
        meta: {
            pageId: 201561,
            title: '薪酬管理',
            keyword: '',
            description: ''
        },
    },
    {
        path: '/company/sickmonth/list',
        name: 'salary_list',
        component: () =>
            import ('./views/company/sickmonth/list/List.vue'),
        meta: {
            pageId: 201561,
            title: '病事假拆分表',
            keyword: '',
            description: ''
        },
    },
    {
        path: '/company/emp/allowanceman/list',
        name: 'company_emp_allowanceman_list',
        component: () =>
            import ('./views/company/emp/allowanceman/list/List.vue'),
        meta: {
            pageId: 2015613,
            title: '津贴管理',
            keyword: '',
            description: ''
        },
    },
    {
        path: '/company/emp/allowanceman/sendapproval',
        name: 'company_emp_allowanceman_detail',
        component: () =>
            import ('./views/company/emp/allowanceman/sendapproval/SendApproval.vue'),
        meta: {
            pageId: 2015613,
            title: '查看',
            keyword: '',
            description: ''
        },
    }, {
        path: '/weita/emp/adlist',
        name: 'weita_emp_adlist',
        component: () =>
            import ('./views/weita/emp/adlist/AdList.vue'),
        meta: {
            pageId: 3001005,
            title: 'AD账户',
            keyword: '',
            description: ''
        },
    },
    {
        path: '/company/set/emppowerset/power',
        name: 'salary_list',
        component: () =>
            import ('./views/company/set/emppowerset/power/Power.vue'),
        meta: {
            pageId: 201561,
            title: '员工权限设置',
            keyword: '',
            description: ''
        },
    },
    // {
    //     path: '/company/set/emppowerset/permissionsetting',
    //     name: 'salary_list',
    //     component: () =>
    //         import ('./views/company/set/emppowerset/permissionsetting/permissionsetting.vue'),
    //     meta: {
    //         pageId: 201561,
    //         title: '员工权限设置',
    //         keyword: '',
    //         description: ''
    //     },
    // },
    {
        path: '/company/set/emppowerset/list',
        name: 'salary_list',
        component: () =>
            import ('./views/company/set/emppowerset/list/List.vue'),
        meta: {
            pageId: 20156123,
            title: '员工权限设置',
            keyword: '',
            description: ''
        },
    },
    {
        path: '/emp/Backupexceptionreport',
        name: 'emp_Backupexceptionreport',
        component: () =>
            import ('./views/company/emp/statistical/backupexceptionreport/Backupexceptionreport.vue'),
        meta: {
            pageId: 20156124,
            title: '备份异常报表',
            keyword: '备份异常报表',
            description: ''
        }
    },
    {
        path: '/company/attanceman/overtimesettle/list',
        name: 'list_OMP',
        component: () =>
            import ('./views/company/attanceman/overtimesettle/list/List.vue'),
        meta: {
            pageId: 201561243,
            title: 'OMP加班结算',
            keyword: 'OMP加班结算',
            description: ''
        }
    },
    {
        path: '/company/attanceman/leavework/list',
        name: 'leavework_list',
        component: () =>
            import ('./views/company/attanceman/leavework/list/List.vue'),
        meta: {
            pageId: 2015612431,
            title: '离职补休结余',
            keyword: '离职补休结余',
            description: ''
        }
    },
    {
        path: '/company/contractmodule/signoverview',
        name: 'SignOverview',
        component: () =>
            import ('./views/company/contractmodule/signoverview/SignOverview.vue'),
        meta: {
            pageId: 20156124312,
            title: '签订概况',
            keyword: '签订概况',
            description: ''
        }
    },
    {
        path: '/company/contractmodule/signoverview/signoverviewdetail',
        name: 'SignOverViewDetail',
        component: () =>
            import ('./views/company/contractmodule/signoverview/signoverviewdetail/SignOverViewDetai.vue'),
        meta: {
            pageId: 20156124312,
            title: '签订概况详情',
            keyword: '签订概况详情',
            description: ''
        }
    },
    {
        path: '/company/contractmodule/elecsign',
        name: 'elecsign',
        component: () =>
            import ('./views/company/contractmodule/elecsign/ElecSign.vue'),
        meta: {
            pageId: 20156124313,
            title: '电子签订',
            keyword: '电子签订',
            description: ''
        }
    },
    {
        path: '/company/contractmodule/elecsiglesign',
        name: 'elecsign',
        component: () =>
            import ('./views/company/contractmodule/elecsiglesign/ElecSigleSign.vue'),
        meta: {
            pageId: 201561243113,
            title: '单个签订',
            keyword: '单个签订',
            description: ''
        }
    },
    {
        path: '/company/contractmodule/elecsign/suminport',
        name: 'elecsign',
        component: () =>
            import ('./views/company/contractmodule/elecsign/suminport/SumInport.vue'),
        meta: {
            pageId: 201561243114,
            title: '批量签订',
            keyword: '批量签订',
            description: ''
        }
    },
    {
        path: '/company/contractmodule/zuofei/invalidfile',
        name: 'invalidfile',
        component: () =>
            import ('./views/company/contractmodule/zuofei/invalidfile/InvalidFile.vue'),
        meta: {
            pageId: 20156124314,
            title: '作废签订文件',
            keyword: '作废签订文件',
            description: ''
        }
    },
    {
        path: '/company/contractmodule/zuofei/singlezuofei',
        name: 'singlezuofei',
        component: () =>
            import ('./views/company/contractmodule/zuofei/singlezuofei/SingleZuofei.vue'),
        meta: {
            pageId: 20156124315,
            title: '单个作废',
            keyword: '单个作废',
            description: ''
        }
    },
    {
        path: '/company/contractmodule/zuofei/singlezuofeigaizhang',
        name: 'singlezuofei',
        component: () =>
            import ('./views/company/contractmodule/zuofei/singlezuofeigaizhang/SingleZuofeiGaizhang.vue'),
        meta: {
            pageId: 201561243155,
            title: '盖章单个作废',
            keyword: '盖章单个作废',
            description: ''
        }
    },
    {
        path: '/company/contractmodule/zuofei/batchzuofei',
        name: 'batchzuofei',
        component: () =>
            import ('./views/company/contractmodule/zuofei/batchzuofei/BatchZuofei.vue'),
        meta: {
            pageId: 20156124316,
            title: '批量作废',
            keyword: '批量作废',
            description: ''
        }
    },
    {
        path: '/company/contractmodule/zuofei/invalidfilhistory',
        name: 'invalidfile',
        component: () =>
            import ('./views/company/contractmodule/zuofei/invalidfilehistory/InvalidFileHistory.vue'),
        meta: {
            pageId: 20156124315,
            title: '作废签订文件历史',
            keyword: '作废签订文件历史',
            description: ''
        }
    },
    {
        path: '/company/contractmodule/zuofei/detail',
        name: 'zuofeidetail',
        component: () =>
            import ('./views/company/contractmodule/zuofei/detail/Detail.vue'),
        meta: {
            pageId: 201561243116,
            title: '查看作废文件',
            keyword: '查看作废文件',
            description: ''
        }
    }, {
        path: '/zhongruan/unscheduled',
        name: 'unscheduled_emp',
        component: () =>
            import ('./views/zhongruan/daily/unscheduled/Unscheduled.vue'),
        meta: {
            pageId: 201561243117,
            title: '未排班人员信息',
            keyword: '未排班人员信息',
            description: ''
        }
    }, {
        path: '/zhongruan/reportform/holevery',
        name: 'reportform_holevery',
        component: () =>
            import ('./views/zhongruan/daily/reportform/holevery/HolEvery.vue'),
        meta: {
            pageId: 201561243118,
            title: '整体请假情况表',
            keyword: '整体请假情况表',
            description: ''
        }
    }, {
        path: '/zhongruan/reportform/holpoolleft',
        name: 'reportform_holpoolleft',
        component: () =>
            import ('./views/zhongruan/daily/reportform/holpoolleft/HolPoolLeft.vue'),
        meta: {
            pageId: 201561243119,
            title: '剩余年假&补休',
            keyword: '剩余年假&补休',
            description: ''
        }
    }, {
        path: '/zhongruan/reportform/empgongchu',
        name: 'reportform_empgongchu',
        component: () =>
            import ('./views/zhongruan/daily/reportform/empgongchu/EmpGongChu.vue'),
        meta: {
            pageId: 201561243120,
            title: '员工公出情况表',
            keyword: '员工公出情况表',
            description: ''
        }
    }, {
        path: '/zhongruan/reportform/stholyear',
        name: 'reportform_stholyear',
        component: () =>
            import ('./views/zhongruan/daily/reportform/stholyear/stHolYear.vue'),
        meta: {
            pageId: 201561243121,
            title: '假期年度汇总',
            keyword: '假期年度汇总',
            description: ''
        }
    }, {
        path: '/zhongruan/reportform/empsanqi',
        name: 'reportform_empsanqi',
        component: () =>
            import ('./views/zhongruan/daily/reportform/empsanqi/empSanQi.vue'),
        meta: {
            pageId: 201561243122,
            title: '三期员工信息表',
            keyword: '三期员工信息表',
            description: ''
        }
    }, {
        path: '/zhongruan/reportform/addresslibrary',
        name: 'reportform_addresslibrary',
        component: () =>
            import ('./views/zhongruan/daily/reportform/addresslibrary/AddressLibrary.vue'),
        meta: {
            pageId: 201561243123,
            title: '打卡地址库信息',
            keyword: '打卡地址库信息',
            description: ''
        }
    }, {
        path: '/zhongruan/reportform/addresswelink',
        name: 'reportform_addresswelink',
        component: () =>
            import ('./views/zhongruan/daily/reportform/addresswelink/AddressWelink.vue'),
        meta: {
            pageId: 201561243124,
            title: 'Welink打卡地址',
            keyword: 'Welink打卡地址',
            description: ''
        }
    }, {
        path: '/zhongruan/reportform/standardworkinghours',
        name: 'reportform_standardworkinghours',
        component: () =>
            import ('./views/zhongruan/daily/reportform/standardworkinghours/StandardWorkingHours.vue'),
        meta: {
            pageId: 201561243125,
            title: '连续三个月均超过月标准工时60小时报表',
            keyword: '连续三个月均超过月标准工时60小时报表',
            description: ''
        }
    }, {
        path: '/zhongruan/reportform/standardworkinghoursdetails',
        name: 'reportform_standardworkinghoursdetails',
        component: () =>
            import ('./views/zhongruan/daily/reportform/standardworkinghoursdetails/StandardWorkingHoursDetails.vue'),
        meta: {
            pageId: 201561243126,
            title: '额外工时大于60H人员明细',
            keyword: '额外工时大于60H人员明细',
            description: ''
        }
    }, {
        path: '/zhongruan/reportform/latetoleavepost',
        name: 'reportform_latetoleavepost',
        component: () =>
            import ('./views/zhongruan/daily/reportform/latetoleavepost/LateToLeavePost.vue'),
        meta: {
            pageId: 201561243127,
            title: '当日离岗较晚员工明细报表',
            keyword: '当日离岗较晚员工明细报表',
            description: ''
        }
    }, {
        path: '/zhongruan/reportform/latetoleavepostdetails',
        name: 'reportform_latetoleavepostdetails',
        component: () =>
            import ('./views/zhongruan/daily/reportform/latetoleavepostdetails/LateToLeavePostDetails.vue'),
        meta: {
            pageId: 201561243128,
            title: '当日离岗较晚员工明细报表详情',
            keyword: '当日离岗较晚员工明细报表详情',
            description: ''
        }
    }, {
        path: '/zhongruan/reportform/moreshiliu',
        name: 'reportform_moreshiliu',
        component: () =>
            import ('./views/zhongruan/daily/reportform/moreshiliu/MoreShiLiu.vue'),
        meta: {
            pageId: 201561243129,
            title: '月晚补次数超过16次人员明细报表',
            keyword: '月晚补次数超过16次人员明细报表',
            description: ''
        }
    }, {
        path: '/zhongruan/reportform/moreshiliudetails',
        name: 'reportform_moreshiliudetails',
        component: () =>
            import ('./views/zhongruan/daily/reportform/moreshiliudetails/MoreShiLiuDetails.vue'),
        meta: {
            pageId: 201561243130,
            title: '月晚补次数超过16次人员明细报表详情',
            keyword: '月晚补次数超过16次人员明细报表详情',
            description: ''
        }
    }, {
        path: '/zhongruan/reportform/moresanshier',
        name: 'reportform_moresanshier',
        component: () =>
            import ('./views/zhongruan/daily/reportform/moresanshier/MoreSanShiEr.vue'),
        meta: {
            pageId: 201561243131,
            title: '月周末出勤时长超32H人员明细报表',
            keyword: '月周末出勤时长超32H人员明细报表',
            description: ''
        }
    }, {
        path: '/zhongruan/reportform/moresanshierdetails',
        name: 'reportform_moresanshierdetails',
        component: () =>
            import ('./views/zhongruan/daily/reportform/moresanshierdetails/MoreSanShiErDetails.vue'),
        meta: {
            pageId: 201561243132,
            title: '月周末出勤时长超32H人员明细报表详情',
            keyword: '月周末出勤时长超32H人员明细报表详情',
            description: ''
        }
    },

    {
        path: '/company/set/salarysetnew/salaryfield',
        name: 'SalaryField',
        component: () =>
            import ('./views/company/set/salarysetnew/scheme/salaryfield/SalaryField.vue'),
        meta: {
            pageId: 1000233,
            title: '薪酬字段设置',
            keyword: '薪酬字段',
            description: '薪酬字段'
        },
    },
    {
        path: '/company/set/salarysetnew/excel',
        name: 'SalaryField',
        component: () =>
            import ('./views/company/set/salarysetnew/scheme/excel/Excel.vue'),
        meta: {
            pageId: 10002331,
            title: '薪酬字段设置',
            keyword: '编辑字段',
            description: '编辑字段'
        },
    },
    {
        path: '/company/salarymodule/inforcollect',
        name: 'SalaryField',
        component: () =>
            import ('./views/company/salarymodule/inforcollect/inforcollection/InforCollection.vue'),
        meta: {
            pageId: 1000222,
            title: '员工数据准备',
            keyword: '员工数据准备',
            description: '员工数据准备'
        },
    },
    {
        path: '/company/salarymodule/inforcollect/add',
        name: 'InforAdd',
        component: () =>
            import ('./views/company/salarymodule/inforcollect/add/Add.vue'),
        meta: {
            pageId: 1000222,
            title: '员工数据准备',
            keyword: '员工数据准备',
            description: '员工数据准备'
        },
    },
    {
        path: '/company/salarymodule/newsalary/salarycalculation',
        name: 'SalaryCalculation',
        component: () =>
            import ('./views/company/salarymodule/newsalary/salarycalculation/SalaryCalculation.vue'),
        meta: {
            pageId: 1000222,
            title: '薪酬核算',
            keyword: '薪酬核算',
            description: '薪酬核算'
        },
    },

    {
        path: '/company/salarymodule/newsalary/synchronousdata',
        name: 'SynchronousData',
        component: () =>
            import ('./views/company/salarymodule/newsalary/synchronousdata/SynchronousData.vue'),
        meta: {
            pageId: 10002221,
            title: '同步数据',
            keyword: '同步数据',
            description: '同步数据'
        },
    },
    {
        path: '/company/salarymodule/newsalary/incometax',
        name: 'IncomeTax',
        component: () =>
            import ('./views/company/salarymodule/newsalary/incometax/IncomeTax.vue'),
        meta: {
            pageId: 100022212,
            title: '个税累计',
            keyword: '个税累计',
            description: '个税累计'
        },
    },
    {
        path: '/company/salarymodule/newsalary/specialaddition',
        name: 'SpecialAddition',
        component: () =>
            import ('./views/company/salarymodule/newsalary/specialaddition/SpecialAddition.vue'),
        meta: {
            pageId: 1000222121,
            title: '专项附加扣除累计',
            keyword: '专项附加扣除累计',
            description: '专项附加扣除累计'
        },
    },
    {
        path: '/company/salarymodule/newsalary/helptip',
        name: 'HelpTip',
        component: () =>
            import ('./views/company/salarymodule/newsalary/helptip/HelpTip.vue'),
        meta: {
            pageId: 10002221212,
            title: '专项附加扣除累计',
            keyword: '专项附加扣除累计',
            description: '专项附加扣除累计'
        },
    },
    {
        path: '/company/salarymodule/newsalary/specificedit',
        name: 'SpecificEdit',
        component: () =>
            import ('./views/company/salarymodule/newsalary/specificedit/SpecificEdit.vue'),
        meta: {
            pageId: 100022212133,
            title: '专项附加扣除累计编辑',
            keyword: '专项附加扣除累计编辑',
            description: '专项附加扣除累计编辑'
        },
    },
    {
        path: '/company/salarymodule/newsalary/icometip',
        name: 'IcomeTip',
        component: () =>
            import ('./views/company/salarymodule/newsalary/icometip/IcomeTip.vue'),
        meta: {
            pageId: 10002221213,
            title: '个税累计',
            keyword: '个税累计',
            description: '个税累计'
        },
    },
    {
        path: '/company/salarymodule/newsalary/incomeedit',
        name: 'incomedit',
        component: () =>
            import ('./views/company/salarymodule/newsalary/incomeedit/incomeEdit.vue'),
        meta: {
            pageId: 100022212133,
            title: '个税累计编辑',
            keyword: '个税累计编辑',
            description: '个税累计编辑'
        },
    },
    {
        path: '/company/salarymodule/newsalary/paythebackup',
        name: 'SynchronousData',
        component: () =>
            import ('./views/company/salarymodule/newsalary/paythebackup/PayTheBackup.vue'),
        meta: {
            pageId: 100022212,
            title: '薪酬备份',
            keyword: '薪酬备份',
            description: '薪酬备份'
        },
    },
    {
        path: '/company/salarymodule/newsalary/paythearchive',
        name: 'SynchronousData',
        component: () =>
            import ('./views/company/salarymodule/newsalary/paythearchive/PayTheArchive.vue'),
        meta: {
            pageId: 100022212,
            title: '薪酬归档',
            keyword: '薪酬归档',
            description: '薪酬归档'
        },
    },
    {
        path: '/company/salarymodule/newsalary/edit',
        name: 'Salaryedit',
        component: () =>
            import ('./views/company/salarymodule/newsalary/edit/Edit.vue'),
        meta: {
            pageId: 1000222121,
            title: '薪酬核算编辑',
            keyword: '薪酬核算编辑',
            description: '薪酬核算编辑'
        },
    },
    {
        path: '/company/salarymodule/newsalary/detail',
        name: 'SalaryDetail',
        component: () =>
            import ('./views/company/salarymodule/newsalary/detail/Detail.vue'),
        meta: {
            pageId: 1000222124,
            title: '查看',
            keyword: '查看',
            description: '查看'
        },
    },

    {
        path: '/company/salarymodule/newsalary/scheme',
        name: 'ManagementList',
        component: () =>
            import ('./views/company/set/salarysetnew/scheme/list/List.vue'),
        meta: {
            pageId: 10002300001,
            title: '薪酬方案管理',
            keyword: '薪酬方案管理',
            description: '薪酬方案管理'
        },
    },
    {
        path: '/company/salarymodule/newsalary/scheme/programme',
        name: 'ManagementProgramme',
        component: () =>
            import ('./views/company/set/salarysetnew/scheme/programme/Programme.vue'),
        meta: {
            pageId: 10002300002,
            title: '薪酬方案管理',
            keyword: '薪酬方案管理',
            description: '薪酬方案管理'
        },
    }, {
        path: '/company/salarymodule/newsalary/rules',
        name: 'newsalary_rules',
        component: () =>
            import ('./views/company/set/salarysetnew/scheme/rulesdetail/RulesDetail.vue'),
        meta: {
            pageId: 10002300003,
            title: '薪酬方案管理',
            keyword: '薪酬方案管理',
            description: '薪酬方案管理'
        },
    }, {
        path: '/company/salarymodule/newsalary/group',
        name: 'newsalary_group',
        component: () =>
            import ('./views/company/set/salarysetnew/group/Group.vue'),
        meta: {
            pageId: 10002300004,
            title: '薪资组管理',
            keyword: '薪资组管理',
            description: '薪资组管理'
        },
    }, {
        path: '/company/salarymodule/newsalary/opentips',
        name: 'newsalary_opentips',
        component: () =>
            import ('./views/company/set/salarysetnew/opentips/OpenTips.vue'),
        meta: {
            pageId: 10002300006,
            title: '薪酬引导页',
            keyword: '引导页',
            description: '引导页'
        },
    }, {
        path: '/privilege/index',
        name: 'privilege_index',
        component: () =>
            import ('./views/privilege/index/Index.vue'),
        meta: {
            pageId: 10002400001,
            title: '企业微信版本权限分配功',
            keyword: '企业微信版本权限分配功',
            description: '企业微信版本权限分配功'
        },
    }, {
        path: '/salaryanaly/wageanaly',
        name: 'wageanaly',
        component: () =>
            import ('./views/company/salarymodule/salaryanaly/wageanaly/WageAnaly.vue'),
        meta: {
            pageId: 10002500001,
            title: '薪酬分析',
            keyword: '薪酬分析',
            description: '薪酬分析'
        },
    },
    {
        path: '/salaryreport/list',
        name: 'salaryreport_List',
        component: () =>
            import ('./views/company/salarymodule/salaryreport/list/List.vue'),
        meta: {
            pageId: 10002600001,
            title: '薪酬报表',
            keyword: '薪酬报表',
            description: '薪酬报表'
        },
    },
    {
        path: '/salarymodule/help',
        name: 'salarymodule_Help',
        component: () =>
            import ('./views/company/salarymodule/help/Help.vue'),
        meta: {
            pageId: 10002600002,
            title: '薪酬帮助',
            keyword: '薪酬帮助',
            description: '薪酬帮助'
        },
    },
    {
        path: '/salarymodule/help',
        name: 'salarymodule_Help',
        component: () =>
            import ('./views/company/salarymodule/help/Help.vue'),
        meta: {
            pageId: 10002600002,
            title: '薪酬帮助',
            keyword: '薪酬帮助',
            description: '薪酬帮助'
        },
    },
    {
        path: '/salaryreport/downfile',
        name: 'salaryreport_DownList',
        component: () =>
            import ('./views/company/salarymodule/salaryreport/downfile/DownFile.vue'),
        meta: {
            pageId: 10002600002,
            title: '薪酬报表',
            keyword: '薪酬报表',
            description: '薪酬报表'
        },
    }, {
        path: '/company/salarymodule/newsalary/startsalary',
        name: 'startsalary',
        component: () =>
            import ('./views/company/salarymodule/newsalary/startsalary/StartSalary.vue'),
        meta: {
            pageId: 10002700001,
            title: '开始算薪',
            keyword: '开始算薪',
            description: '开始算薪'
        },
    }, {
        path: '/company/salarymodule/newsalary/salarydata',
        name: 'SalaryData',
        component: () =>
            import ('./views/company/salarymodule/newsalary/salarydata/SalaryData.vue'),
        meta: {
            pageId: 10002700002,
            title: '智能薪酬',
            keyword: '智能薪酬',
            description: '智能薪酬'
        },
    }, {
        path: '/company/salarymodule/newsalary/addsalary',
        name: 'newsalary_opentips',
        component: () =>
            import ('./views/company/salarymodule/newsalary/addsalary/AddSalary.vue'),
        meta: {
            pageId: 10002700003,
            title: '添加薪资组',
            keyword: '添加薪资组',
            description: '添加薪资组'
        },
    },
    {
        path: '/company/attanceman/applicantSum/applyList',
        name: 'applyList',
        component: () =>
            import ('./views/company/attanceman/applicantSum/applyList/ApplyList.vue'),
        meta: {
            pageId: 10002800001,
            title: '申报人数汇总表',
            keyword: '申报人数汇总表',
            description: ''
        }
    },
    {
        path: '/company/attanceman/applicantSum/applyDetail',
        name: 'ApplyDetail',
        component: () =>
            import ('./views/company/attanceman/applicantSum/applyDetail/ApplyDetail.vue'),
        meta: {
            pageId: 10002800002,
            title: '申报人员明细表',
            keyword: '申报人员明细表',
            description: ''
        }
    },
    {
        path: '/company/attanceman/applicantSum/noApplyList',
        name: 'NoApplyList',
        component: () =>
            import ('./views/company/attanceman/applicantSum/noApplyList/NoApplyList.vue'),
        meta: {
            pageId: 10002800003,
            title: '未申报汇总表',
            keyword: '未申报汇总表',
            description: ''
        }
    },
    {
        path: '/company/attanceman/applicantSum/noApplyDetail',
        name: 'NoApplyDetail',
        component: () =>
            import ('./views/company/attanceman/applicantSum/noApplyDetail/NoApplyDetail.vue'),
        meta: {
            pageId: 10002800003,
            title: '未申报明细表',
            keyword: '未申报明细表',
            description: ''
        }
    },
    {
        path: '/company/attanceman/applicantSum/applyExceptList',
        name: 'ApplyExceptList',
        component: () =>
            import ('./views/company/attanceman/applicantSum/applyExceptList/ApplyExceptList.vue'),
        meta: {
            pageId: 10002800004,
            title: '申报地异常汇总',
            keyword: '申报地异常汇总',
            description: ''
        }
    },
    {
        path: '/company/attanceman/applicantSum/applyExceptDetail',
        name: 'ApplyExceptDetail',
        component: () =>
            import ('./views/company/attanceman/applicantSum/applyExceptDetail/ApplyExceptDetail.vue'),
        meta: {
            pageId: 10002800005,
            title: '申报地异常明细',
            keyword: '申报地异常明细',
            description: ''
        }
    },






    //------------------------------------------------------------------------
    //集团账号(我的账号)
    //------------------------------------------------------------------------
    {
        path: '/authen/login',
        name: 'authen_login',
        component: () =>
            import ('./views/authen/views/main/login/Login.vue'),
        meta: {
            pageId: 656425823001,
            title: '登录',
            keyword: '登录',
            description: ''
        }
    },
    {
        path: '/authen/test',
        name: 'authen_test',
        component: () =>
            import ('./views/authen/views/main/test/Test.vue'),
        meta: {
            pageId: 656425823002,
            title: '测试',
            keyword: '测试',
            description: ''
        }
    },
    {
        path: '/authen/usermanager/list',
        name: 'authen_usermanager_list',
        component: () =>
            import ('./views/authen/views/user/list/List.vue'),
        meta: {
            pageId: 656425823003,
            title: '用户管理列表',
            keyword: '用户管理列表',
            description: ''
        }
    },
    {
        path: '/authen/usermanager/detaillist',
        name: 'authen_usermanager_detaillist',
        component: () =>
            import ('./views/authen/views/user/detaillist/DetailList.vue'),
        meta: {
            pageId: 656425823004,
            title: '用户管理详情列表',
            keyword: '用户管理详情列表',
            description: ''
        }
    },
    {
        path: '/authen/usermanager/editor',
        name: 'authen_usermanager_editor',
        component: () =>
            import ('./views/authen/views/user/editor/Editor.vue'),
        meta: {
            pageId: 656425823005,
            title: '用户管理编辑',
            keyword: '用户管理编辑',
            description: ''
        }
    },
    {
        path: '/authen/usermanager/rightsmanager',
        name: 'authen_usermanager_rightsmanager',
        component: () =>
            import ('./views/authen/views/user/rightsmanager/RightsManager.vue'),
        meta: {
            pageId: 656425823006,
            title: '权限管理',
            keyword: '权限管理',
            description: ''
        }
    },
    {
        path: '/authen/usermanager/assignpermissions',
        name: 'authen_usermanager_assignpermissions',
        component: () =>
            import ('./views/authen/views/user/assignpermissions/AssignPermissions.vue'),
        meta: {
            pageId: 656425823007,
            title: '权限分配',
            keyword: '权限分配',
            description: ''
        }
    }, {
        path: '/authen/usermanager/editorcompany',
        name: 'authen_usermanager_editorcompany',
        component: () =>
            import ('./views/authen/views/user/editorcompany/EditorCompany.vue'),
        meta: {
            pageId: 656425823008,
            title: '编辑修改公司',
            keyword: '编辑修改公司',
            description: ''
        }
    }, {
        path: '/authen/usermanager/comapnyuserlist',
        name: 'authen_usermanager_comapnyuserlist',
        component: () =>
            import ('./views/authen/views/user/comapnyuserlist/ComapnyUserList.vue'),
        meta: {
            pageId: 656425823009,
            title: '公司用户列表',
            keyword: '公司用户列表',
            description: ''
        }
    }, {
        path: '/authen/resetpassword',
        name: 'authen_resetpassword',
        component: () =>
            import ('./views/authen/views/main/resetpassword/ResetPassword.vue'),
        meta: {
            pageId: 656425823010,
            title: '忘记密码',
            keyword: '忘记密码',
            description: ''
        }
    },
    {
        path: '/authen/main/account',
        name: 'authen_main_account',
        component: () =>
            import ('./views/authen/views/main/editaccount/EditAccount.vue'),
        meta: {
            pageId: 656425823011,
            title: '个人信息设置',
            keyword: '个人信息设置',
            description: ''
        }
    }, {
        path: '/authen/contract/list',
        name: 'authen_contract_list',
        component: () =>
            import ('./views/authen/views/contract/list/List.vue'),
        meta: {
            pageId: 656425823012,
            title: '合同管理列表',
            keyword: '合同管理列表',
            description: ''
        }
    }, {
        path: '/authen/set/companymanagement',
        name: 'company_management',
        component: () =>
            import ('./views/authen/views/set/companymanagement/CompanyManagement.vue'),
        meta: {
            pageId: 10416096002,
            title: '公司管理',
            keyword: '公司管理',
            description: ''
        }
    }, {
        path: '/authen/set/rolemanagement',
        name: 'company_management',
        component: () =>
            import ('./views/authen/views/set/rolemanagement/RoleManagement.vue'),
        meta: {
            pageId: 10416097001,
            title: '角色管理',
            keyword: '角色管理',
            description: ''
        }
    }, {
        path: '/authen/newmenu',
        name: 'menu',
        component: () =>
            import ('./views/authen/views/newmenu/NewMenu.vue'),
        meta: {
            pageId: 10416096002,
            title: '菜单管理',
            keyword: '菜单管理',
            description: ''
        }
    }, {
        path: '/authen/legalperson',
        name: 'legalperson',
        component: () =>
            import ('./views/authen/views/set/legalperson/index/LegalPersonIndex.vue'),
        meta: {
            pageId: 10416098001,
            title: '法人主体',
            keyword: '法人主体',
            description: ''
        }
    }, {
        path: '/authen/legalpersonadd',
        name: 'legalperson_add',
        component: () =>
            import ('./views/authen/views/set/legalperson/add/LegalPersonAdd.vue'),
        meta: {
            pageId: 10416098002,
            title: '新增法人主体',
            keyword: '新增法人主体',
            description: ''
        }
    }, {
        path: '/authen/legalpersonedit',
        name: 'legalperson_edit',
        component: () =>
            import ('./views/authen/views/set/legalperson/edit/LegalPersonEdit.vue'),
        meta: {
            pageId: 10416098003,
            title: '修改法人主体',
            keyword: '修改法人主体',
            description: ''
        }
    }, {
        path: '/authen/legalpersonsee',
        name: 'legalperson_see',
        component: () =>
            import ('./views/authen/views/set/legalperson/see/LegalPersonSee.vue'),
        meta: {
            pageId: 10416098004,
            title: '查看法人主体',
            keyword: '查看法人主体',
            description: ''
        }
    }, {
        path: '/authen/legalpersondetailed',
        name: 'legalperson_detailed',
        component: () =>
            import ('./views/authen/views/set/legalperson/detailed/LegalPersonDetailed.vue'),
        meta: {
            pageId: 10416098005,
            title: '法人主体明细',
            keyword: '法人主体明细',
            description: ''
        }
    }, {
        path: '/authen/legalpersoncustpage',
        name: 'legalperson_custpage',
        component: () =>
            import ('./views/authen/views/set/legalperson/custpage/CustPage.vue'),
        meta: {
            pageId: 10416098006,
            title: '适用客户列表',
            keyword: '适用客户列表',
            description: ''
        }
    }, {
        path: '/authen/templatelibrary',
        name: 'template_library_index',
        component: () =>
            import ('./views/authen/views/set/templatelibrary/index/TemplateLibraryIndex.vue'),
        meta: {
            pageId: 10416099001,
            title: '签订类型管理',
            keyword: '签订类型管理',
            description: ''
        }
    }, {
        path: '/authen/templatelibrarysetup',
        name: 'template_library_setup',
        component: () =>
            import ('./views/authen/views/set/templatelibrary/setup/TemplateLibrarySetUp.vue'),
        meta: {
            pageId: 10416099002,
            title: '签订类型管理',
            keyword: '签订类型管理',
            description: ''
        }
    },
    {
        path: '/authen/templatelibrarycustpage',
        name: 'templatelibrary_custpage',
        component: () =>
            import ('./views/authen/views/set/templatelibrary/custpage/CustPage.vue'),
        meta: {
            pageId: 10416099004,
            title: '适用客户列表',
            keyword: '适用客户列表',
            description: ''
        }
    }, {
        path: '/authen/templatelibrary/addwork',
        name: 'template_library_addwork',
        component: () =>
            import ('./views/authen/views/set/templatelibrary/templateworkcertificate/TemplateWorkCertificate.vue'),
        meta: {
            pageId: 10416099003,
            title: '新增模板',
            keyword: '新增模板',
            description: ''
        }
    }, {
        path: '/authen/templatelibrary/addcontract',
        name: 'template_library_addcontract',
        component: () =>
            import ('./views/authen/views/set/templatelibrary/templatecontract/TemplateContract.vue'),
        meta: {
            pageId: 10416099004,
            title: '新增模板',
            keyword: '新增模板',
            description: ''
        }
    }, {
        path: '/authen/templatelibrary/tempfieldset',
        name: 'templatelibrary_tempfieldset',
        component: () =>
            import ('./views/authen/views/set/templatelibrary/tempfieldset/TempFieldSet.vue'),
        meta: {
            pageId: 10416099005,
            title: '模板对应字段标签',
            keyword: '模板对应字段标签',
            description: '模板对应字段标签'
        },
    }, {
        path: '/authen/templatelibrary/tempmodeset',
        name: 'addmoban',
        component: () =>
            import ('./views/authen/views/set/templatelibrary/tempmodeset/TempModeSet.vue'),
        meta: {
            pageId: 10416099006,
            title: '配置模板',
            keyword: '配置模板',
            description: '配置模板'
        },
    }, {
        path: '/authen/echart/companies',
        name: 'echart_companies',
        component: () =>
            import ('./views/authen/views/echart/companies/Companies.vue'),
        meta: {
            pageId: 500000001,
            title: ' 代理商管理公司数量统计',
            keyword: ' 代理商管理公司数量统计',
            description: ' 代理商管理公司数量统计'
        },
    }, {
        path: '/authen/echart/emp',
        name: 'echart_emp',
        component: () =>
            import ('./views/authen/views/echart/emp/Emp.vue'),
        meta: {
            pageId: 500000002,
            title: ' 公司员工数量统计',
            keyword: ' 公司员工数量统计',
            description: ' 公司员工数量统计'
        },
    }, {
        path: '/authen/set/seal',
        name: 'seal_management',
        component: () =>
            import ('./views/authen/views/set/seal/Seal.vue'),
        meta: {
            pageId: 10416100001,
            title: '印章管理',
            keyword: '印章管理',
            description: ''
        }
    }, {
        path: '/authen/error/403',
        name: 'authen_error_403',
        component: () =>
            import ('./views/authen/views/main/code403/Code403.vue'),
        meta: {
            pageId: 6564258230090,
            title: '403',
            keyword: '403',
            description: ''
        }
    }, {
        path: '/authen/main/welcome',
        name: 'authen_main_welcome',
        component: () =>
            import ('./views/authen/views/main/welcome/Welcome.vue'),
        meta: {
            pageId: 6564258230091,
            title: 'welcome',
            keyword: 'welcome',
            description: ''
        }
    },

    //------------------------------------------------------------------------
    //集团账号结束
    //------------------------------------------------------------------------

    {
        path: '/company/orginfobyvita/list',
        name: 'orginfo_vita_orglist',
        component: () =>
            import ('./views/company/orginfobyvita/list/List.vue'),
        meta: {
            pageId: 10002288811142,
            title: '部门负责人管理',
            keyword: '部门负责人',
            description: '部门负责人管理'
        },
    },
    {
        path: '/company/qiyewechatmonthreport/listpage',
        name: 'qiyewechatmonthreport',
        component: () =>
            import ('./views/company/qiyewechatmonthreport/listpage/list/List.vue'),
        meta: {
            pageId: 999999999901,
            title: '企业微信月报',
            keyword: '企业微信月报',
            description: '企业微信月报'
        },
    },
    {
        path: '/company/qiyewechatmonthreport/setpage',
        name: 'qymonthreportset',
        component: () =>
            import ('./views/company/qiyewechatmonthreport/setpage/list/List.vue'),
        meta: {
            pageId: 999999999911,
            title: '企业微信月报设置',
            keyword: '企业微信月报设置',
            description: '企业微信月报设置'
        },
    },
    {
        path: '/company/qiyewechatmonthreport/setpage/addmonthrule',
        name: 'qymonthreportadd',
        component: () =>
            import ('./views/company/qiyewechatmonthreport/setpage/addmonthrule/AddMonthRule.vue'),
        meta: {
            pageId: 999999999912,
            title: '新增企业微信月报规则',
            keyword: '新增企业微信月报规则',
            description: '新增企业微信月报规则'
        },
    },
    {
        path: '/company/qiyewechatmonthreport/setpage/lookmonthrule',
        name: 'qymonthreportlook',
        component: () =>
            import ('./views/company/qiyewechatmonthreport/setpage/lookmonthrule/LookMonthRule.vue'),
        meta: {
            pageId: 9999999999112,
            title: '查看企业微信月报规则',
            keyword: '查看企业微信月报规则',
            description: '查看企业微信月报规则'
        },
    },
    {
        path: '/company/qiyewechatmonthreport/listpage/editdata',
        name: 'qymontheditdata',
        component: () =>
            import ('./views/company/qiyewechatmonthreport/listpage/editdata/EditData.vue'),
        meta: {
            pageId: 999999999913,
            title: '修改企业微信月报',
            keyword: '修改企业微信月报',
            description: '修改企业微信月报'
        },
    },
    {
        path: '/company/qiyewechatmonthreport/listpage/lookdata',
        name: 'qymonthlookdata',
        component: () =>
            import ('./views/company/qiyewechatmonthreport/listpage/lookdata/LookData.vue'),
        meta: {
            pageId: 999999999914,
            title: '查看企业微信月报',
            keyword: '查看企业微信月报',
            description: '查看企业微信月报'
        },
    }, {
        path: '/company/qiyewechatmonthreport/secret',
        name: 'secret',
        component: () =>
            import ('./views/company/qiyewechatmonthreport/help/secret/Secret.vue'),
        meta: {
            pageId: 999999999915,
            title: '企业Secret信息绑定',
            keyword: '企业Secret信息绑定',
            description: '企业Secret信息绑定'
        },
    }, {
        path: '/company/qiyewechatmonthreport/bindhelp',
        name: 'bindhelp',
        component: () =>
            import ('./views/company/qiyewechatmonthreport/help/bindhelp/BindHelp.vue'),
        meta: {
            pageId: 999999999916,
            title: '企业Secret信息绑定引导',
            keyword: '企业Secret信息绑定引导',
            description: '企业Secret信息绑定引导'
        },
    }, {
        path: '/company/qiyewechatmonthreport/gethelp',
        name: 'gethelp',
        component: () =>
            import ('./views/company/qiyewechatmonthreport/help/gethelp/GetHelp.vue'),
        meta: {
            pageId: 999999999917,
            title: '企业Secret信息获取引导',
            keyword: '企业Secret信息获取引导',
            description: '企业Secret信息获取引导'
        },
    },
    {
        path: '/company/buqingrecords/buka',
        name: 'buka',
        component: () =>
            import ('./views/company/buqingrecords/buka/BuKa.vue'),
        meta: {
            pageId: 9999776655100,
            title: '补卡记录',
            keyword: '补卡记录',
            description: '补卡记录'
        },
    },
    {
        path: '/company/buqingrecords/holiday',
        name: 'holiday',
        component: () =>
            import ('./views/company/buqingrecords/holiday/Holiday.vue'),
        meta: {
            pageId: 9999776655101,
            title: '补请假记录',
            keyword: '补请假记录',
            description: '补请假记录'
        },
    },
    {
        path: '/company/buqingrecords/overtime',
        name: 'holiday',
        component: () =>
            import ('./views/company/buqingrecords/overtime/OverTime.vue'),
        meta: {
            pageId: 9999776655102,
            title: '补加班记录',
            keyword: '补加班记录',
            description: '补加班记录'
        },
    },
    {
        path: "/company/buqingrecords/detail",
        name: "buqing_detail",
        component: () =>
            import ('./views/company/buqingrecords/detail/Detail.vue'),
        meta: {
            pageId: 99997766551000,
            title: '补请记录详情',
            keyword: '补请记录详情',
            description: '补请记录详情'
        }
    },


    {
        path: '/msg/welcome',
        name: 'welcome',
        component: () =>
            import ('./views/msg/welcome/Welcome.vue'),
        meta: {
            pageId: 10002288811142,
            title: '欢迎',
            keyword: '欢迎',
            description: '欢迎'
        },
    }, {
        path: '/company/set/empset/archiveset',
        name: 'empset_archiveset',
        component: () =>
            import ('./views/company/set/empset/archiveset/ArchiveSet.vue'),
        meta: {
            pageId: 100082,
            title: '员工档案设置',
            keyword: '设置',
            description: '员工档案设置'
        },
    },
    {
        path: '/company/user/filelist',
        name: 'userfilelist',
        component: () =>
            import ('./views/company/emp/userfiles/list/List.vue'),
        meta: {
            pageId: 100071,
            title: '档案管理',
            keyword: '档案',
            description: '档案信息'
        },
    },
    {
        path: '/emp/employed/supplementexport',
        name: 'emp_employed_supplementexport',
        component: () =>
            import ('./views/company/emp/onjob/supplementaryinfoexport/SupplementaryInfoExport.vue'),
        meta: {
            pageId: 20107,
            title: '员工补充信息',
            keyword: '',
            description: ''
        },
    },
    {
        path: '/personal/acquisition/list',
        name: 'acquisition_list',
        component: () =>
            import ('./views/personal/acquisition/acquisitionlist/AcquisitionList.vue'),
        meta: {
            pageId: 20000002002,
            title: '员工端-数据采集',
            keyword: '',
            description: ''
        },
    },
    {
        path: '/personal/acquisition/datalist',
        name: 'acquisition_datalist',
        component: () =>
            import ('./views/personal/acquisition/acquisitiondatalist/AcquisitionDataList.vue'),
        meta: {
            pageId: 20000002003,
            title: '员工端-数据采集',
            keyword: '',
            description: ''
        },
    },
    {
        path: '/personal/acquisition/edit',
        name: 'acquisition_edit',
        component: () =>
            import ('./views/personal/acquisition/acquisitionedit/AcquisitionEdit.vue'),
        meta: {
            pageId: 20000002003,
            title: '员工端-数据采集',
            keyword: '',
            description: ''
        },
    },{
        path: '/personal/acquisitionmanage/list',
        name: 'acquisition_manage_list',
        component: () =>
            import ('./views/personal/acquisitionmanage/acquisitionlist/AcquisitionList.vue'),
        meta: {
            pageId: 200000020010,
            title: '管理端-数据采集',
            keyword: '',
            description: ''
        },
    },
    {
        path: '/personal/acquisitionmanage/datalist',
        name: 'acquisition_manage_datalist',
        component: () =>
            import ('./views/personal/acquisitionmanage/acquisitiondatalist/AcquisitionDataList.vue'),
        meta: {
            pageId: 200000020020,
            title: '管理端-数据采集',
            keyword: '',
            description: ''
        },
    },
    {
        path: '/personal/acquisitionmanage/edit',
        name: 'acquisition_manage_edit',
        component: () =>
            import ('./views/personal/acquisitionmanage/acquisitionedit/AcquisitionEdit.vue'),
        meta: {
            pageId: 200000020030,
            title: '管理端-数据采集',
            keyword: '',
            description: ''
        },
    },{
        path: '/personal/acquisition/import',
        name: 'acquisition_import',
        component: () =>
            import ('./views/personal/acquisition/import/Import.vue'),
        meta: {
            pageId: 200000020040,
            title: '员工端-导入',
            keyword: '',
            description: ''
        },
    },
    {
        path: '/personal/acquisitionmanage/import',
        name: 'acquisition_import',
        component: () =>
            import ('./views/personal/acquisitionmanage/import/Import.vue'),
        meta: {
            pageId: 200000020050,
            title: '管理端-导入',
            keyword: '',
            description: ''
        },
    },
]



export default mainRoutes